var _style, _g, _defs, _line, _line2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _rect, _g10, _path, _text, _text2, _text3, _text4, _path2, _path3, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _g11, _g12, _path4, _g13, _g14, _polyline, _polyline2, _line3, _circle, _g15, _line4, _circle2, _circle3, _circle4, _circle5, _rect2, _g16, _path5, _text13, _text14, _text15, _g17, _g18, _path6, _path7, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _g19, _g20, _g21, _text26, _text27, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomely03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 727.8 348.2",
    style: {
      enableBackground: "new 0 0 727.8 348.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.17;fill:#2066BA;}\n\t.st2{fill:#257AF4;}\n\t.st3{fill:#2066BA;}\n\t.st4{fill:#1A1A1E;}\n\t.st5{fill:#383747;}\n\t.st6{fill:#ED760A;}\n\t.st7{fill:#02D196;}\n\t.st8{fill:#EF3A3A;}\n\t.st9{fill:#333333;}\n\t.st10{fill:url(#SVGID_00000043441852502420364920000003899518499400381579_);}\n\t.st11{fill:url(#SVGID_00000107585057906667746250000015715989125486111925_);}\n\t.st12{fill:#FFFFFF;}\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:4.5828;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{fill:#1A1A1E;stroke:#FFFFFF;stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#FFFFFF;stroke-width:8.0198;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st16{fill:#F6F5EE;}\n\t.st17{fill:url(#SVGID_00000006701053374264702710000014703359413721384362_);}\n\t.st18{fill:url(#SVGID_00000016794158201367510340000009851807512711383208_);}\n\t.st19{fill:none;stroke:#000000;stroke-width:8.0198;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st20{fill:none;stroke:#000000;stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{fill:#FFFFFF;stroke:#000000;stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st22{fill:none;stroke:url(#SVGID_00000134250649332149566600000009899423023650882732_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st23{fill:none;stroke:url(#SVGID_00000005249195505513111710000010573311092137467066_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st24{fill:none;stroke:url(#SVGID_00000109742345544778471260000001903623614110411684_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st25{fill:none;stroke:url(#SVGID_00000027585977195058557050000000563920121175731073_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st26{fill:none;stroke:url(#SVGID_00000051365811393933782700000007911127886601962654_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st27{fill:none;stroke:url(#SVGID_00000034811606323567959310000010159248884198578304_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st28{fill:none;stroke:url(#SVGID_00000081620515577863950520000009818313680258884752_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st29{fill:none;stroke:url(#SVGID_00000156557375225397907720000005387118741371419787_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st30{fill:none;stroke:url(#SVGID_00000042706063051150757480000002657818785347257743_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st31{fill:none;stroke:url(#SVGID_00000065758595992853221600000006656217922199179181_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st32{fill:none;stroke:url(#SVGID_00000024690497240549424140000003304605907747074983_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st33{fill:none;stroke:url(#SVGID_00000132086421702546844390000006236766114071278008_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st34{fill:none;stroke:url(#SVGID_00000154409750073614354510000008195453916880727450_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st35{fill:none;stroke:url(#SVGID_00000029010345715843609820000005906033654101283733_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st36{fill:none;stroke:url(#SVGID_00000114062566824128388200000010077968817495658403_);stroke-width:2.73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st37{fill:url(#SVGID_00000034056489148591018000000004459000323412582297_);}\n\t.st38{fill:url(#SVGID_00000046340170034502749590000016434495152610093495_);}\n\t.st39{fill:#9E56CC;}\n\t.st40{fill:#2E67CE;}\n\t.st41{fill:#FC3D3D;}\n\t.st42{fill:#6A8D93;}\n\t.st43{fill:#F9C319;}\n\t.st44{fill:#B3B3B3;}\n\t.st45{fill:url(#SVGID_00000098195719788942118420000002873172925455751307_);}\n\t.st46{fill:url(#SVGID_00000173144538280174423970000011163627914242654877_);}\n\t.st47{fill:url(#SVGID_00000014621925054847602250000000798901790864418702_);}\n\t.st48{fill:url(#SVGID_00000032632832229769555940000004697007928418698136_);}\n\t.st49{fill:url(#SVGID_00000181081005816855648630000017337351939860130198_);}\n\t.st50{fill:url(#SVGID_00000163072926611723576700000008454688991155549362_);}\n\t.st51{fill:#CCCBC5;}\n\t.st52{fill:#FF931E;}\n\t.st53{fill:url(#SVGID_00000164509566533519852150000009787533064486812845_);}\n\t.st54{fill:url(#SVGID_00000065770401363516968500000014360788633859177150_);}\n\t.st55{fill:#F95085;}\n\t.st56{fill:#3FA9F5;}\n\t.st57{fill:#255599;}\n\t.st58{fill:url(#SVGID_00000182502427422667208790000000405343507231839144_);}\n\t.st59{fill:url(#SVGID_00000162348611113247174170000008111213325557060744_);}\n\t.st60{fill:url(#SVGID_00000137812015074816287720000015784703010165761684_);}\n\t.st61{fill:url(#SVGID_00000114055244136162293130000011219116844572749229_);}\n\t.st62{fill:url(#SVGID_00000026851710333067507690000001193748369818522524_);}\n\t.st63{fill:url(#SVGID_00000132811041080081913650000009915880500289107371_);}\n\t.st64{fill:url(#SVGID_00000090999844306580386140000016072294249965965740_);}\n\t.st65{fill:url(#SVGID_00000047741536091291092170000017419772348325523647_);}\n\t.st66{fill:url(#SVGID_00000036930712455190390980000015150844875266778814_);}\n\t.st67{fill:url(#SVGID_00000122700141956774702810000017565391300787960237_);}\n\t.st68{fill:url(#SVGID_00000085248529572862848000000003635172282895627405_);}\n\t.st69{fill:url(#SVGID_00000008141312904536716390000000281986425241599360_);}\n\t.st70{fill:url(#SVGID_00000144314302987749827250000008616950252168348324_);}\n\t.st71{fill:#1A1A1A;}\n\t.st72{fill:#464559;}\n\t.st73{opacity:0.25;}\n\t.st74{fill:url(#SVGID_00000161605634116207644590000012848278787768074678_);}\n\t.st75{fill:url(#SVGID_00000036229141208102869340000002580489639171537051_);}\n\t.st76{fill:url(#SVGID_00000163757651608924833430000006701069542827250325_);}\n\t.st77{fill:url(#SVGID_00000008111476793166540080000013642585096282354833_);}\n\t.st78{fill:#2D3332;}\n\t.st79{fill:#FC636F;}\n\t.st80{fill:#F7E861;}\n\t.st81{fill:#8AED7C;}\n\t.st82{fill:#565959;}\n\t.st83{fill:none;stroke:#FFFFFF;stroke-width:2.9413;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st84{fill:#FF1D25;}\n\t.st85{fill:#FCEE21;}\n\t.st86{fill:#7AC943;}\n\t.st87{fill:none;stroke:#FFFFFF;stroke-width:4.9973;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st88{fill:none;stroke:#FFFFFF;stroke-width:2.2031;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st89{fill:none;stroke:#000000;stroke-width:0.3362;stroke-miterlimit:10;}\n\t.st90{fill:#CCCCCC;}\n\t.st91{fill:#FFFFFF;stroke:#000000;stroke-width:0.3171;stroke-miterlimit:10;}\n\t.st92{font-family:'CenturyGothicPro-Bold';}\n\t.st93{font-size:4.841px;}\n\t.st94{fill:none;stroke:#000000;stroke-width:0.3118;stroke-miterlimit:10;}\n\t.st95{fill:none;stroke:#000000;stroke-width:0.311;stroke-miterlimit:10;}\n\t.st96{fill:#FFFFFF;stroke:#000000;stroke-width:0.3118;stroke-miterlimit:10;}\n\t.st97{fill:#FFFFFF;stroke:#000000;stroke-width:0.2447;stroke-miterlimit:10;}\n\t.st98{font-size:2.4205px;}\n\t.st99{fill:none;}\n\t.st100{font-family:'CenturyGothicPro';}\n\t.st101{font-size:1.6137px;}\n\t.st102{font-size:1.4119px;}\n\t.st103{font-family:'CenturyGothicPro-BoldItalic';}\n\t.st104{fill:none;stroke:#000000;stroke-width:0.3362;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st105{fill:none;stroke:#000000;stroke-width:0.3093;stroke-miterlimit:10;}\n\t.st106{fill:#FFFFFF;stroke:#000000;stroke-width:0.3093;stroke-miterlimit:10;}\n\t.st107{fill:#FFFFFF;stroke:#000000;stroke-width:0.2017;stroke-miterlimit:10;}\n\t.st108{fill:#FFFFFF;stroke:#000000;stroke-width:0.3362;stroke-miterlimit:10;}\n\t.st109{font-size:3.2273px;}\n\t.st110{fill:none;stroke:#000000;stroke-width:0.3362;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st111{fill:none;stroke:#808080;stroke-width:0.3362;stroke-miterlimit:10;}\n\t.st112{font-size:2.2696px;}\n\t.st113{letter-spacing:1;}\n\t.st114{font-family:'CenturyGothicPro-Italic';}\n\t.st115{font-size:4.088px;}\n\t.st116{font-size:2.7181px;}\n\t.st117{fill:#F6F2E8;}\n\t.st118{font-size:9.782px;}\n\t.st119{font-size:5.6307px;}\n\t.st120{font-size:10.2148px;}\n\t.st121{font-size:3.7538px;}\n\t.st122{fill:url(#SVGID_00000169518348394827079370000006447542558762985144_);}\n\t.st123{fill:url(#SVGID_00000170273129306187509480000009776083944914397339_);}\n\t.st124{fill:url(#SVGID_00000154410523809288561030000015303763336559069828_);}\n\t.st125{fill:url(#SVGID_00000156586693755278433750000001748864722960685992_);}\n\t.st126{fill:url(#SVGID_00000046338223462358378650000018022842698608067729_);}\n\t.st127{fill:url(#SVGID_00000010274402601681406680000007136911174153363606_);}\n\t.st128{fill:url(#SVGID_00000107568229683391653420000008526019323578635411_);}\n\t.st129{fill:url(#SVGID_00000047056240181107039790000002412656791282700675_);}\n\t.st130{fill:url(#SVGID_00000072238524531359998610000005327912273956208553_);}\n\t.st131{fill:none;stroke:#9E56CC;stroke-width:0.7323;stroke-miterlimit:10;}\n\t.st132{fill:#F93838;}\n\t.st133{fill:none;stroke:#000000;stroke-width:0.9384;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st134{fill:none;stroke:#000000;stroke-width:0.1564;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st135{font-size:3.9233px;}\n\t.st136{fill:url(#SVGID_00000127752274725201280730000003114684915254474149_);}\n\t.st137{fill:url(#SVGID_00000031185551321128346630000009449598482778125963_);}\n\t.st138{fill:url(#SVGID_00000171717574838480345900000014135899758505751697_);}\n\t.st139{fill:url(#SVGID_00000013192803893001225020000011321502584082319513_);}\n\t.st140{fill:url(#SVGID_00000103964123896834364600000002703579589343588240_);}\n\t.st141{fill:url(#SVGID_00000046339666310245545690000007949190215619077009_);}\n\t.st142{letter-spacing:-3;}\n\t.st143{letter-spacing:-1;}\n\t.st144{fill:#83CC79;}\n\t.st145{font-size:3.8079px;}\n\t.st146{fill:url(#SVGID_00000104696163302232319840000017996970919485039767_);}\n\t.st147{fill:url(#SVGID_00000129894438193842834380000012445860742704067731_);}\n\t.st148{fill:url(#SVGID_00000114769907114733773980000014005998695487807648_);}\n\t.st149{fill:url(#SVGID_00000023994967303376325170000016914335476174802078_);}\n\t.st150{fill:url(#SVGID_00000031899800297789598950000004459860146072161977_);}\n\t.st151{font-size:3.2208px;}\n\t.st152{font-size:4.4549px;}\n\t.st153{font-size:3.7813px;}\n\t\n\t\t.st154{clip-path:url(#SVGID_00000085249719663602811190000002016334035811599489_);fill:#FFFFFF;stroke:#000000;stroke-width:2.6043;stroke-miterlimit:10;}\n\t\n\t\t.st155{clip-path:url(#SVGID_00000155127691734472634560000012453953166117822895_);fill:#FFFFFF;stroke:#000000;stroke-width:2.6043;stroke-miterlimit:10;}\n\t\n\t\t.st156{clip-path:url(#SVGID_00000108281902586272674260000002618792978998002841_);fill:#FFFFFF;stroke:#000000;stroke-width:2.6043;stroke-miterlimit:10;}\n\t.st157{fill:#05CEC3;}\n\t.st158{fill:none;stroke:#FFFFFF;stroke-width:2.4516;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000165230643948553114380000011417060119344092863_",
    d: "M-171.2-2307.2v576.1c0,22.6-18.4,41-41,41h-222.5 c-22.6,0-41-18.4-41-41v-576.1c0-22.6,18.4-41,41-41h38.8c3.2,0,5.7,2.6,5.7,5.7v4.2c0,9.6,7.8,17.4,17.4,17.4h98.6 c9.6,0,17.4-7.8,17.4-17.4v-4.2c0-3.2,2.6-5.7,5.7-5.7h38.8C-189.6-2348.2-171.2-2329.8-171.2-2307.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000045609799306104142510000014786383453664237712_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165230643948553114380000011417060119344092863_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 176.3,
    y1: 127.9,
    x2: 176.3,
    y2: 113.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 244.3,
    y1: 113.3,
    x2: 244.3,
    y2: 127.9
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 178.2,
    className: "st90",
    width: 75.6,
    height: 167.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M240,339.8h4.1v-2c0-1.1-0.9-2-2-2l0,0c-1.1,0-2,0.9-2,2V339.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 242,
    cy: 334.2,
    r: 1.1
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 206.1686 192.2431)",
    className: "st92 st93"
  }, "Chat"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M247,328.3h-70.3c-1.5,0-2.7,1.2-2.7,2.7v14.6h75.6v-14.6C249.7,329.5,248.5,328.3,247,328.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M198.9,337.4h3c0.2,0,0.4-0.2,0.4-0.4v-3.4c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4 C198.5,337.2,198.6,337.4,198.9,337.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M198.9,341.6h3c0.2,0,0.4-0.2,0.4-0.4v-2.2c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2 C198.5,341.4,198.6,341.6,198.9,341.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M206.8,337.3h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-3.4 C207.2,337.5,207,337.3,206.8,337.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M206.8,333.1h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-2.2 C207.2,333.3,207,333.1,206.8,333.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M226.4,333.8h-6.6c-0.3,0-0.6,0.3-0.6,0.6v2.1c0,0.3,0.3,0.6,0.6,0.6h6c0.3,0,0.6-0.3,0.6-0.6V333.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M214.5,336.2h8.6c0.4,0,0.8,0.4,0.8,0.8v2.7c0,0.4-0.4,0.8-0.8,0.8h-7.8c-0.4,0-0.8-0.4-0.8-0.8V336.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.1,
    y: 333.1,
    className: "st89",
    width: 8.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M239.3,194.7h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2h-4.3c-1.2,0-2.2,1-2.2,2.2v4.3 C237.1,193.7,238.1,194.7,239.3,194.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M183,213.7h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2H183c-1.2,0-2.2,1-2.2,2.2v4.3 C180.7,212.7,181.7,213.7,183,213.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st97",
    x1: 220.2,
    y1: 335.3,
    x2: 225.4,
    y2: 335.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 217.3,
    cy: 338.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 219.2,
    cy: 338.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 221.1,
    cy: 338.3,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M236,341.4h5.5v-2.8c0-1.5-1.2-2.8-2.8-2.8l0,0c-1.5,0-2.8,1.2-2.8,2.8V341.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 238.7,
    cy: 333.8,
    r: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.097 208.2128)",
    className: "st92 st98"
  }, "Leasing Office"), /*#__PURE__*/React.createElement("rect", {
    x: 192.1,
    y: 209.3,
    className: "st99",
    width: 42.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.1225 210.736)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st100 st101"
  }, "This is a the chat with the leasing office showing a prev "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1.9,
    className: "st100 st101"
  }, "of last message")), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M183,228.4h4.3c1.2,0,2.2-1,2.2-2.2V222c0-1.2-1-2.2-2.2-2.2H183c-1.2,0-2.2,1-2.2,2.2v4.3 C180.7,227.4,181.7,228.4,183,228.4z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.097 222.9504)",
    className: "st92 st98"
  }, "Maintenance"), /*#__PURE__*/React.createElement("rect", {
    x: 192.1,
    y: 224.1,
    className: "st99",
    width: 42.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.1225 225.4736)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st100 st101"
  }, "This is a the chat with the leasing office showing a prev "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1.9,
    className: "st100 st101"
  }, "of last message")), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M245.8,216.8h-67.9v-11.9c0-1.4,1.2-2.6,2.6-2.6h62.7c1.4,0,2.6,1.2,2.6,2.6V216.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M177.9,216.8h67.9v11.9c0,1.4-1.2,2.6-2.6,2.6h-62.7c-1.4,0-2.6-1.2-2.6-2.6V216.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M183,250.7h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2H183c-1.2,0-2.2,1-2.2,2.2v4.3 C180.7,249.7,181.7,250.7,183,250.7z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.097 245.2209)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st92 st98"
  }, "Mark Hamill "), /*#__PURE__*/React.createElement("tspan", {
    x: 14.6,
    y: 0,
    className: "st92 st102"
  }, "(Above Neighbor #302)")), /*#__PURE__*/React.createElement("rect", {
    x: 192.1,
    y: 246.4,
    className: "st99",
    width: 42.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.1225 247.7441)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st100 st101"
  }, "This is a the chat with the leasing office showing a prev "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1.9,
    className: "st100 st101"
  }, "of last message")), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M245.8,253.8h-67.9v-12c0-1.4,1.1-2.6,2.6-2.6h62.8c1.4,0,2.6,1.1,2.6,2.6V253.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M183,265.3h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2H183c-1.2,0-2.2,1-2.2,2.2v4.3 C180.7,264.3,181.7,265.3,183,265.3z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.097 259.7807)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st92 st98"
  }, "Oscar Issac "), /*#__PURE__*/React.createElement("tspan", {
    x: 14.3,
    y: 0,
    className: "st92 st102"
  }, "(Left Neighbor #201)")), /*#__PURE__*/React.createElement("rect", {
    x: 192.1,
    y: 260.9,
    className: "st99",
    width: 42.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.1225 262.3039)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st100 st101"
  }, "This is a the chat with the leasing office showing a prev "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1.9,
    className: "st100 st101"
  }, "of last message")), /*#__PURE__*/React.createElement("rect", {
    x: 177.9,
    y: 253.8,
    className: "st89",
    width: 67.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M183,279.8h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2H183c-1.2,0-2.2,1-2.2,2.2v4.3 C180.7,278.8,181.7,279.8,183,279.8z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.097 274.3405)",
    className: "st92 st98"
  }, "Leasing Office"), /*#__PURE__*/React.createElement("rect", {
    x: 192.1,
    y: 275.5,
    className: "st99",
    width: 42.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.1225 276.8637)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st100 st101"
  }, "This is a the chat with the leasing office showing a prev "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1.9,
    className: "st100 st101"
  }, "of last message")), /*#__PURE__*/React.createElement("rect", {
    x: 177.9,
    y: 268.4,
    className: "st89",
    width: 67.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M183,294.4h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2H183c-1.2,0-2.2,1-2.2,2.2v4.3 C180.7,293.4,181.7,294.4,183,294.4z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.097 288.9005)",
    className: "st92 st98"
  }, "Leasing Office"), /*#__PURE__*/React.createElement("rect", {
    x: 192.1,
    y: 290,
    className: "st99",
    width: 42.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.1225 291.4237)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st100 st101"
  }, "This is a the chat with the leasing office showing a prev "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1.9,
    className: "st100 st101"
  }, "of last message")), /*#__PURE__*/React.createElement("rect", {
    x: 177.9,
    y: 282.9,
    className: "st89",
    width: 67.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 245.8,
    y1: 294.8,
    x2: 245.8,
    y2: 309.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 177.9,
    y1: 309.4,
    x2: 177.9,
    y2: 294.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 177.9,
    y1: 304.2,
    x2: 177.9,
    y2: 289.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 245.8,
    y1: 289.6,
    x2: 245.8,
    y2: 304.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M245.8,304.2v11.9c0,1.4-1.2,2.6-2.6,2.6h-62.7c-1.4,0-2.6-1.2-2.6-2.6v-11.9"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 179.326 237.1122)",
    className: "st103 st98"
  }, "Neighbors"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 179.326 200.4677)",
    className: "st103 st98"
  }, "Administration"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 173.2,
    y: 2,
    className: "st90",
    width: 75.6,
    height: 167.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M239.2,163.5h4.1v-2c0-1.1-0.9-2-2-2l0,0c-1.1,0-2,0.9-2,2V163.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 241.2,
    cy: 157.9,
    r: 1.1
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 205.3944 15.9738)",
    className: "st92 st93"
  }, "Chat"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M246.2,152h-70.3c-1.5,0-2.7,1.2-2.7,2.7v14.6h75.6v-14.6C248.9,153.2,247.7,152,246.2,152z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M198.1,161.1h3c0.2,0,0.4-0.2,0.4-0.4v-3.4c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4 C197.7,160.9,197.9,161.1,198.1,161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M198.1,165.3h3c0.2,0,0.4-0.2,0.4-0.4v-2.2c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2 C197.7,165.1,197.9,165.3,198.1,165.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M206,161h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-3.4 C206.4,161.2,206.2,161,206,161z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M206,156.8h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-2.2 C206.4,157,206.2,156.8,206,156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M225.6,157.5H219c-0.3,0-0.6,0.3-0.6,0.6v2.1c0,0.3,0.3,0.6,0.6,0.6h6c0.3,0,0.6-0.3,0.6-0.6V157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M213.7,159.9h8.6c0.4,0,0.8,0.4,0.8,0.8v2.7c0,0.4-0.4,0.8-0.8,0.8h-7.8c-0.4,0-0.8-0.4-0.8-0.8V159.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.3,
    y: 156.8,
    className: "st89",
    width: 8.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M238.5,18.4h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2h-4.3c-1.2,0-2.2,1-2.2,2.2v4.3 C236.3,17.4,237.3,18.4,238.5,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M179.3,18.4h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2h-4.3c-1.2,0-2.2,1-2.2,2.2v4.3 C177.1,17.4,178.1,18.4,179.3,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M182.2,37.4h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2h-4.3c-1.2,0-2.2,1-2.2,2.2v4.3 C180,36.4,181,37.4,182.2,37.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st97",
    x1: 219.4,
    y1: 159.1,
    x2: 224.6,
    y2: 159.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 216.5,
    cy: 162,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 218.4,
    cy: 162,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 220.3,
    cy: 162,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M235.2,165.1h5.5v-2.8c0-1.5-1.2-2.8-2.8-2.8h0c-1.5,0-2.8,1.2-2.8,2.8V165.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 237.9,
    cy: 157.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 191.3228 31.9433)",
    className: "st92 st98"
  }, "Leasing Office"), /*#__PURE__*/React.createElement("rect", {
    x: 191.3,
    y: 33.1,
    className: "st99",
    width: 42.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 191.3484 34.4665)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st100 st101"
  }, "This is a the chat with the leasing office showing a prev "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1.9,
    className: "st100 st101"
  }, "of last message")), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M245,40.5h-67.9V28.6c0-1.4,1.2-2.6,2.6-2.6h62.7c1.4,0,2.6,1.2,2.6,2.6V40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M182.2,52h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2h-4.3c-1.2,0-2.2,1-2.2,2.2v4.3 C180,51,181,52,182.2,52z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 191.3228 46.5033)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st92 st98"
  }, "Mark Hamill "), /*#__PURE__*/React.createElement("tspan", {
    x: 14.6,
    y: 0,
    className: "st92 st102"
  }, "(Above Neighbor #302)")), /*#__PURE__*/React.createElement("rect", {
    x: 191.3,
    y: 47.6,
    className: "st99",
    width: 42.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 191.3484 49.0263)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st100 st101"
  }, "This is a the chat with the leasing office showing a prev "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1.9,
    className: "st100 st101"
  }, "of last message")), /*#__PURE__*/React.createElement("rect", {
    x: 177.1,
    y: 40.5,
    className: "st89",
    width: 67.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M182.2,66.6h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2h-4.3c-1.2,0-2.2,1-2.2,2.2v4.3 C180,65.6,181,66.6,182.2,66.6z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 191.3228 61.0629)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st92 st98"
  }, "Oscar Issac "), /*#__PURE__*/React.createElement("tspan", {
    x: 14.3,
    y: 0,
    className: "st92 st102"
  }, "(Left Neighbor #201)")), /*#__PURE__*/React.createElement("rect", {
    x: 191.3,
    y: 62.2,
    className: "st99",
    width: 42.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 191.3484 63.5863)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st100 st101"
  }, "This is a the chat with the leasing office showing a prev "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1.9,
    className: "st100 st101"
  }, "of last message")), /*#__PURE__*/React.createElement("rect", {
    x: 177.1,
    y: 55.1,
    className: "st89",
    width: 67.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M182.2,81.1h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2h-4.3c-1.2,0-2.2,1-2.2,2.2v4.3 C180,80.1,181,81.1,182.2,81.1z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 191.3228 75.623)",
    className: "st92 st98"
  }, "Leasing Office"), /*#__PURE__*/React.createElement("rect", {
    x: 191.3,
    y: 76.8,
    className: "st99",
    width: 42.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 191.3484 78.1462)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st100 st101"
  }, "This is a the chat with the leasing office showing a prev "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1.9,
    className: "st100 st101"
  }, "of last message")), /*#__PURE__*/React.createElement("rect", {
    x: 177.1,
    y: 69.7,
    className: "st89",
    width: 67.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M182.2,95.7h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2h-4.3c-1.2,0-2.2,1-2.2,2.2v4.3 C180,94.7,181,95.7,182.2,95.7z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 191.3228 90.1828)",
    className: "st92 st98"
  }, "Leasing Office"), /*#__PURE__*/React.createElement("rect", {
    x: 191.3,
    y: 91.3,
    className: "st99",
    width: 42.8,
    height: 3.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 191.3484 92.706)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st100 st101"
  }, "This is a the chat with the leasing office showing a prev "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1.9,
    className: "st100 st101"
  }, "of last message")), /*#__PURE__*/React.createElement("rect", {
    x: 177.1,
    y: 84.2,
    className: "st89",
    width: 67.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st89",
    points: "177.1,113.3 177.1,98.8 245,98.8 245,113.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M245,113.3v26.5c0,1.4-1.2,2.6-2.6,2.6h-62.7c-1.4,0-2.6-1.2-2.6-2.6v-26.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st104",
    points: "184.1,14 180,14 181.7,12.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st104",
    x1: 180,
    y1: 14,
    x2: 181.6,
    y2: 15.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 259.7,
    y: 2,
    className: "st90",
    width: 75.6,
    height: 167.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M325.7,163.5h4.1v-2c0-1.1-0.9-2-2-2l0,0c-1.1,0-2,0.9-2,2V163.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 327.7,
    cy: 157.9,
    r: 1.1
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 289.048 15.9738)",
    className: "st92 st93"
  }, "Utilities"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M332.7,152h-70.3c-1.5,0-2.7,1.2-2.7,2.7v14.6h75.6v-14.6C335.4,153.2,334.2,152,332.7,152z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M284.6,161.1h3c0.2,0,0.4-0.2,0.4-0.4v-3.4c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4 C284.2,160.9,284.4,161.1,284.6,161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M284.6,165.3h3c0.2,0,0.4-0.2,0.4-0.4v-2.2c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2 C284.2,165.1,284.4,165.3,284.6,165.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M292.5,161h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-3.4 C292.9,161.2,292.7,161,292.5,161z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M292.5,156.8h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-2.2 C292.9,157,292.7,156.8,292.5,156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M312.1,157.5h-6.6c-0.3,0-0.6,0.3-0.6,0.6v2.1c0,0.3,0.3,0.6,0.6,0.6h6c0.3,0,0.6-0.3,0.6-0.6V157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M300.2,159.9h8.6c0.4,0,0.8,0.4,0.8,0.8v2.7c0,0.4-0.4,0.8-0.8,0.8H301c-0.4,0-0.8-0.4-0.8-0.8V159.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.8,
    y: 156.8,
    className: "st89",
    width: 8.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M282.5,43.2h-13.1c-1.2,0-2.1-0.9-2.1-2.1V27.9c0-1.2,0.9-2.1,2.1-2.1h13.1c1.2,0,2.1,0.9,2.1,2.1v13.1 C284.7,42.2,283.7,43.2,282.5,43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M304.1,43.2H291c-1.2,0-2.1-0.9-2.1-2.1V27.9c0-1.2,0.9-2.1,2.1-2.1h13.1c1.2,0,2.1,0.9,2.1,2.1v13.1 C306.2,42.2,305.3,43.2,304.1,43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M325.7,43.2h-13.1c-1.2,0-2.1-0.9-2.1-2.1V27.9c0-1.2,0.9-2.1,2.1-2.1h13.1c1.2,0,2.1,0.9,2.1,2.1v13.1 C327.8,42.2,326.8,43.2,325.7,43.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M282.5,66.3h-13.1c-1.2,0-2.1-0.9-2.1-2.1V51.1c0-1.2,0.9-2.1,2.1-2.1h13.1c1.2,0,2.1,0.9,2.1,2.1v13.1 C284.7,65.4,283.7,66.3,282.5,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M304.1,66.3H291c-1.2,0-2.1-0.9-2.1-2.1V51.1c0-1.2,0.9-2.1,2.1-2.1h13.1c1.2,0,2.1,0.9,2.1,2.1v13.1 C306.2,65.4,305.3,66.3,304.1,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M325.7,66.3h-13.1c-1.2,0-2.1-0.9-2.1-2.1V51.1c0-1.2,0.9-2.1,2.1-2.1h13.1c1.2,0,2.1,0.9,2.1,2.1v13.1 C327.8,65.4,326.8,66.3,325.7,66.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M325,18.4h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2H325c-1.2,0-2.2,1-2.2,2.2v4.3 C322.8,17.4,323.8,18.4,325,18.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st97",
    x1: 305.9,
    y1: 159.1,
    x2: 311.1,
    y2: 159.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 303,
    cy: 162,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 304.9,
    cy: 162,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 306.8,
    cy: 162,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M321.7,165.1h5.5v-2.8c0-1.5-1.2-2.8-2.8-2.8l0,0c-1.5,0-2.8,1.2-2.8,2.8V165.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 324.4,
    cy: 157.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 30.4,
    className: "st105",
    width: 9.9,
    height: 8.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M301,61.8h-6.9c-0.8,0-1.5-0.7-1.5-1.5v-5.2c0-0.8,0.7-1.5,1.5-1.5h6.9c0.8,0,1.5,0.7,1.5,1.5v5.2 C302.5,61.2,301.8,61.8,301,61.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "280.9,60.3 280.9,52 271,52 271,60.3 272.7,63.1 274.4,60.1 275.3,61.4 276.9,59.2 279,62.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.2,
    y: 34,
    className: "st105",
    width: 9.9,
    height: 4.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "324.1,34 314.2,34 314.8,31.9 323.4,31.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "320.8,33.4 316.2,33.4 316.5,32.5 320.5,32.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "323,32.5 320.8,33.4 320.5,32.5 322.5,31.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M297.5,31.6c1.9-2.9,4.9,0,4.9,0v5.6h-9.9v-5.6C292.6,31.6,295.7,28.8,297.5,31.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st105",
    x1: 276,
    y1: 30.4,
    x2: 276,
    y2: 38.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st105",
    cx: 274.4,
    cy: 34.7,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st105",
    cx: 277.4,
    cy: 34.7,
    r: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st105",
    x1: 302.5,
    y1: 37.2,
    x2: 302.5,
    y2: 38.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st105",
    x1: 292.6,
    y1: 37.2,
    x2: 292.6,
    y2: 38.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st105",
    x1: 294.4,
    y1: 30.6,
    x2: 294.4,
    y2: 38.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st105",
    x1: 296,
    y1: 30.6,
    x2: 296,
    y2: 38.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st105",
    x1: 297.5,
    y1: 31.6,
    x2: 297.5,
    y2: 38.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st105",
    x1: 299.1,
    y1: 30.6,
    x2: 299.1,
    y2: 38.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st105",
    x1: 300.8,
    y1: 30.6,
    x2: 300.8,
    y2: 38.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st105",
    x1: 302.5,
    y1: 31.6,
    x2: 302.5,
    y2: 30.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st105",
    x1: 292.6,
    y1: 31.6,
    x2: 292.6,
    y2: 30.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st105",
    cx: 292.6,
    cy: 30.4,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st105",
    cx: 302.5,
    cy: 30.4,
    r: 0.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st106",
    points: "321.4,37.2 322.1,40.1 316.2,40.1 316.8,37.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st106",
    x1: 314.2,
    y1: 36.3,
    x2: 324.1,
    y2: 36.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.8,
    y: 36.3,
    className: "st106",
    width: 4.5,
    height: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st105",
    cx: 273.3,
    cy: 54.7,
    r: 1.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st105",
    x1: 275.4,
    y1: 54.7,
    x2: 279.5,
    y2: 54.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 56.7,
    className: "st105",
    width: 1.9,
    height: 1.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "304,55.3 304,52 300,52 300,55.3 300.7,56.4 301.4,55.2 301.7,55.8 302.3,54.9 303.2,56.1  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st107",
    cx: 300.9,
    cy: 53.1,
    r: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st107",
    x1: 301.8,
    y1: 53.1,
    x2: 303.4,
    y2: 53.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.6,
    y: 53.9,
    className: "st107",
    width: 0.8,
    height: 0.8
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st105",
    cx: 297.5,
    cy: 57.9,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st105",
    cx: 297.5,
    cy: 57.9,
    r: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 55.4,
    className: "st105",
    width: 1.9,
    height: 0.9
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 269.8194 45.7387)",
    className: "st92 st98"
  }, "Front Door"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 291.2552 45.7387)",
    className: "st92 st98"
  }, "Front Gate"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 315.455 45.7387)",
    className: "st92 st98"
  }, "Printer"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 267.6516 69.1401)",
    className: "st92 st98"
  }, "Service Ticket"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 290.4394 69.1401)",
    className: "st92 st98"
  }, "Report Issue"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 314.3831 69.1401)",
    className: "st92 st98"
  }, "Package"), /*#__PURE__*/React.createElement("rect", {
    x: 314.4,
    y: 53.1,
    className: "st89",
    width: 9.4,
    height: 8.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 317.9,
    y1: 53.1,
    x2: 317.9,
    y2: 61.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 320.5,
    y1: 61.4,
    x2: 320.5,
    y2: 53.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.4,
    y: 56.2,
    className: "st108",
    width: 9.4,
    height: 2.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 2,
    className: "st90",
    width: 75.6,
    height: 167.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M65.9,163.5H70v-2c0-1.1-0.9-2-2-2l0,0c-1.1,0-2,0.9-2,2V163.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 68,
    cy: 157.9,
    r: 1.1
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 23.7921 15.9738)",
    className: "st92 st93"
  }, "Dashboard"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M73,152H2.7c-1.5,0-2.7,1.2-2.7,2.7v14.6h75.6v-14.6C75.6,153.2,74.4,152,73,152z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M24.9,161.1h3c0.2,0,0.4-0.2,0.4-0.4v-3.4c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4 C24.4,160.9,24.6,161.1,24.9,161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M24.9,165.3h3c0.2,0,0.4-0.2,0.4-0.4v-2.2c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2 C24.4,165.1,24.6,165.3,24.9,165.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M32.8,161h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-3.4 C33.2,161.2,33,161,32.8,161z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M32.8,156.8h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-2.2 C33.2,157,33,156.8,32.8,156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M52.4,157.5h-6.6c-0.3,0-0.6,0.3-0.6,0.6v2.1c0,0.3,0.3,0.6,0.6,0.6h6c0.3,0,0.6-0.3,0.6-0.6V157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M40.5,159.9H49c0.4,0,0.8,0.4,0.8,0.8v2.7c0,0.4-0.4,0.8-0.8,0.8h-7.8c-0.4,0-0.8-0.4-0.8-0.8V159.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.1,
    y: 156.8,
    className: "st89",
    width: 8.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 5.0343 52.061)",
    className: "st92 st109"
  }, "Announcements"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M69.2,68.4H6.5c-1.4,0-2.6-1.2-2.6-2.6v-9.3c0-1.4,1.2-2.6,2.6-2.6h62.7c1.4,0,2.6,1.2,2.6,2.6v9.3 C71.8,67.3,70.6,68.4,69.2,68.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.1,
    y: 57,
    className: "st89",
    width: 8.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 20.8,
    y1: 57,
    x2: 49.4,
    y2: 57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 20.8,
    y1: 61.1,
    x2: 32.1,
    y2: 61.1
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 6.0277 121.6925)",
    className: "st92 st109"
  }, "Classified"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M69.2,92.4H6.5c-1.4,0-2.6-1.2-2.6-2.6v-9.3c0-1.4,1.2-2.6,2.6-2.6h62.7c1.4,0,2.6,1.2,2.6,2.6v9.3 C71.8,91.2,70.6,92.4,69.2,92.4z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 5.0343 75.9909)",
    className: "st92 st109"
  }, "Service Ticket Update"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M14.1,88.3v-6.4c0-0.5-0.4-1-1-1H8.1c-0.5,0-1,0.4-1,1v6.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 20.8,
    y1: 80.9,
    x2: 49.4,
    y2: 80.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 20.8,
    y1: 85.1,
    x2: 32.1,
    y2: 85.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M21.3,143.7H8.1c-1.2,0-2.1-0.9-2.1-2.1v-13.1c0-1.2,0.9-2.1,2.1-2.1h13.1c1.2,0,2.1,0.9,2.1,2.1v13.1 C23.4,142.7,22.4,143.7,21.3,143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M42.8,143.7H29.7c-1.2,0-2.1-0.9-2.1-2.1v-13.1c0-1.2,0.9-2.1,2.1-2.1h13.1c1.2,0,2.1,0.9,2.1,2.1v13.1 C45,142.7,44,143.7,42.8,143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M64.4,143.7H51.3c-1.2,0-2.1-0.9-2.1-2.1v-13.1c0-1.2,0.9-2.1,2.1-2.1h13.1c1.2,0,2.1,0.9,2.1,2.1v13.1 C66.5,142.7,65.6,143.7,64.4,143.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st97",
    x1: 46.1,
    y1: 159.1,
    x2: 51.4,
    y2: 159.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 43.3,
    cy: 162,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 45.2,
    cy: 162,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 47.1,
    cy: 162,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M61.9,165.1h5.5v-2.8c0-1.5-1.2-2.8-2.8-2.8h0c-1.5,0-2.8,1.2-2.8,2.8V165.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 64.7,
    cy: 157.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st110",
    points: "8.9,88.3 8.4,89.1 8,89.9 7.5,89.1 7.1,88.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st110",
    points: "10.6,88.3 10.2,89.1 9.7,89.9 9.3,89.1 8.9,88.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st110",
    points: "12.4,88.3 11.9,89.1 11.5,89.9 11.1,89.1 10.6,88.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st110",
    points: "14.1,88.3 13.7,89.1 13.2,89.9 12.8,89.1 12.4,88.3  "
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st110",
    cx: 9.2,
    cy: 82.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st110",
    x1: 10.8,
    y1: 82.9,
    x2: 13.2,
    y2: 82.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st110",
    x1: 8.5,
    y1: 85.1,
    x2: 13,
    y2: 85.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st110",
    x1: 8.5,
    y1: 86,
    x2: 13,
    y2: 86
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M69.2,45.2H6.5c-1.4,0-2.6-1.2-2.6-2.6v-9.3c0-1.4,1.2-2.6,2.6-2.6h62.7c1.4,0,2.6,1.2,2.6,2.6v9.3 C71.8,44,70.6,45.2,69.2,45.2z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 5.0343 28.8319)",
    className: "st92 st109"
  }, "Chats"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M63.8,45.2H6.5c-1.4,0-2.6-1.2-2.6-2.6v-9.3c0-1.4,1.2-2.6,2.6-2.6h57.3c1.4,0,2.6,1.2,2.6,2.6v9.3 C66.4,44,65.2,45.2,63.8,45.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 20.8,
    y1: 33.7,
    x2: 49.4,
    y2: 33.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 20.8,
    y1: 37.9,
    x2: 32.1,
    y2: 37.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M17.2,34.6h-6.6c-0.3,0-0.6,0.3-0.6,0.6v2.1c0,0.3,0.3,0.6,0.6,0.6h6c0.3,0,0.6-0.3,0.6-0.6V34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M5.3,36.9h8.6c0.4,0,0.8,0.4,0.8,0.8v2.7c0,0.4-0.4,0.8-0.8,0.8H6.1c-0.4,0-0.8-0.4-0.8-0.8V36.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st97",
    x1: 11,
    y1: 36.1,
    x2: 16.2,
    y2: 36.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 8.1,
    cy: 39.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 10,
    cy: 39.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 11.9,
    cy: 39.1,
    r: 0.5
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "17.2,27.6 16.7,28.1 16.2,28.5 16.2,27.6 16.2,26.7 16.7,27.2  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "41.8,75.1 41.3,75.5 40.7,76 40.7,75.1 40.7,74.2 41.3,74.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "33.2,51.3 32.6,51.7 32.1,52.2 32.1,51.3 32.1,50.3 32.6,50.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M48.4,38.5h21.2c1.2,0,2.2-1,2.2-2.2V11.9c0-1.2-1-2.2-2.2-2.2H48.4c-1.2,0-2.2,1-2.2,2.2v24.4 C46.1,37.5,47.1,38.5,48.4,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M65.3,18.4h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2h-4.3c-1.2,0-2.2,1-2.2,2.2v4.3 C63.1,17.4,64.1,18.4,65.3,18.4z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 48.3272 15.3266)",
    className: "st92 st112"
  }, "Gabe Klein"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 50.2575 24.4421)",
    className: "st92 st112"
  }, "Account Setting"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 54.7003 33.7345)",
    className: "st92 st112"
  }, "Log Out"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 50.456 29.0883)",
    className: "st92 st112"
  }, "Incentive Code"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 86.5,
    y: 2,
    className: "st90",
    width: 75.6,
    height: 167.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M152.7,163.5h4.1v-2c0-1.1-0.9-2-2-2l0,0c-1.1,0-2,0.9-2,2V163.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 154.7,
    cy: 157.9,
    r: 1.1
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 110.5451 15.9736)",
    className: "st92 st93"
  }, "Dashboard"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M159.7,152H89.4c-1.5,0-2.7,1.2-2.7,2.7v14.6h75.6v-14.6C162.4,153.2,161.2,152,159.7,152z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M111.6,161.1h3c0.2,0,0.4-0.2,0.4-0.4v-3.4c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4 C111.2,160.9,111.4,161.1,111.6,161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M111.6,165.3h3c0.2,0,0.4-0.2,0.4-0.4v-2.2c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2 C111.2,165.1,111.4,165.3,111.6,165.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M119.5,161h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-3.4 C119.9,161.2,119.7,161,119.5,161z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M119.5,156.8h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-2.2 C119.9,157,119.7,156.8,119.5,156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M139.2,157.5h-6.6c-0.3,0-0.6,0.3-0.6,0.6v2.1c0,0.3,0.3,0.6,0.6,0.6h6c0.3,0,0.6-0.3,0.6-0.6V157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M127.2,159.9h8.6c0.4,0,0.8,0.4,0.8,0.8v2.7c0,0.4-0.4,0.8-0.8,0.8H128c-0.4,0-0.8-0.4-0.8-0.8V159.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.9,
    y: 156.8,
    className: "st89",
    width: 8.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 91.7874 52.061)",
    className: "st92 st109"
  }, "Announcements"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M155.9,68.4H93.2c-1.4,0-2.6-1.2-2.6-2.6v-9.3c0-1.4,1.2-2.6,2.6-2.6h62.7c1.4,0,2.6,1.2,2.6,2.6v9.3 C158.5,67.3,157.4,68.4,155.9,68.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.9,
    y: 57,
    className: "st89",
    width: 8.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 107.6,
    y1: 57,
    x2: 136.1,
    y2: 57
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 107.6,
    y1: 61.1,
    x2: 118.8,
    y2: 61.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M155.9,92.4H93.2c-1.4,0-2.6-1.2-2.6-2.6v-9.3c0-1.4,1.2-2.6,2.6-2.6h62.7c1.4,0,2.6,1.2,2.6,2.6v9.3 C158.5,91.2,157.4,92.4,155.9,92.4z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 91.7874 75.9909)",
    className: "st92 st109"
  }, "Service Ticket Update"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 91.7874 99.4482)",
    className: "st92 st109"
  }, "Pay Bill"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M100.9,88.3v-6.4c0-0.5-0.4-1-1-1h-5.1c-0.5,0-1,0.4-1,1v6.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 107.6,
    y1: 80.9,
    x2: 136.1,
    y2: 80.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 107.6,
    y1: 85.1,
    x2: 118.8,
    y2: 85.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M152.1,18.4h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2h-4.3c-1.2,0-2.2,1-2.2,2.2v4.3 C149.8,17.4,150.8,18.4,152.1,18.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st97",
    x1: 132.9,
    y1: 159.1,
    x2: 138.1,
    y2: 159.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 130,
    cy: 162,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 131.9,
    cy: 162,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 133.8,
    cy: 162,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M148.7,165.1h5.5v-2.8c0-1.5-1.2-2.8-2.8-2.8l0,0c-1.5,0-2.8,1.2-2.8,2.8V165.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 151.4,
    cy: 157.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st110",
    points: "95.6,88.3 95.2,89.1 94.7,89.9 94.3,89.1 93.9,88.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st110",
    points: "97.4,88.3 96.9,89.1 96.5,89.9 96.1,89.1 95.6,88.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st110",
    points: "99.1,88.3 98.7,89.1 98.2,89.9 97.8,89.1 97.4,88.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st110",
    points: "100.9,88.3 100.4,89.1 100,89.9 99.6,89.1 99.1,88.3  "
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st110",
    cx: 95.9,
    cy: 82.9,
    r: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st110",
    x1: 97.6,
    y1: 82.9,
    x2: 100,
    y2: 82.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st110",
    x1: 95.2,
    y1: 85.1,
    x2: 99.8,
    y2: 85.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st110",
    x1: 95.2,
    y1: 86,
    x2: 99.8,
    y2: 86
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M155.9,46.7h-62c-1.4,0-2.6-1.2-2.6-2.6v-9.3c0-1.4,1.2-2.6,2.6-2.6h62c1.4,0,2.6,1.2,2.6,2.6v9.3 C158.5,45.6,157.4,46.7,155.9,46.7z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 91.7874 28.8317)",
    className: "st92 st109"
  }, "Chats"), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M154.6,45.2H93.2c-1.4,0-2.6-1.2-2.6-2.6v-9.3c0-1.4,1.2-2.6,2.6-2.6h61.4c1.4,0,2.6,1.2,2.6,2.6v9.3 C157.2,44,156,45.2,154.6,45.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 107.6,
    y1: 33.7,
    x2: 136.1,
    y2: 33.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 107.6,
    y1: 37.9,
    x2: 118.8,
    y2: 37.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M104,34.6h-6.6c-0.3,0-0.6,0.3-0.6,0.6v2.1c0,0.3,0.3,0.6,0.6,0.6h6c0.3,0,0.6-0.3,0.6-0.6V34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M92.1,36.9h8.6c0.4,0,0.8,0.4,0.8,0.8v2.7c0,0.4-0.4,0.8-0.8,0.8h-7.8c-0.4,0-0.8-0.4-0.8-0.8V36.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st97",
    x1: 97.7,
    y1: 36.1,
    x2: 103,
    y2: 36.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 94.9,
    cy: 39.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 96.8,
    cy: 39.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 98.7,
    cy: 39.1,
    r: 0.5
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "104,27.6 103.5,28.1 102.9,28.5 102.9,27.6 102.9,26.7 103.5,27.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "128.6,75.1 128,75.5 127.5,76 127.5,75.1 127.5,74.2 128,74.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "119.9,51.3 119.4,51.7 118.8,52.2 118.8,51.3 118.8,50.3 119.4,50.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M120.2,121.1H92.9c-1.4,0-2.6-1.2-2.6-2.6v-14.3c0-1.4,1.2-2.6,2.6-2.6h27.3c1.4,0,2.6,1.2,2.6,2.6v14.3 C122.8,119.9,121.7,121.1,120.2,121.1z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 127.0401 99.4482)",
    className: "st92 st109"
  }, "Event"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M155.5,121.1h-27.3c-1.4,0-2.6-1.2-2.6-2.6v-14.3c0-1.4,1.2-2.6,2.6-2.6h27.3c1.4,0,2.6,1.2,2.6,2.6v14.3 C158.1,119.9,156.9,121.1,155.5,121.1z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 178.2,
    className: "st90",
    width: 75.6,
    height: 167.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M9,212.9h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2H9c-1.2,0-2.2,1-2.2,2.2v4.3 C6.7,211.9,7.7,212.9,9,212.9z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 20.3699 210.3918)",
    className: "st92 st109"
  }, "Leasing Documents"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 6.7344 199.0932)",
    className: "st92 st109"
  }, "Billing"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 6.7344 238.5776)",
    className: "st92 st109"
  }, "Profile"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 20.3699 224.6391)",
    className: "st92 st109"
  }, "Payment Details"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 19.2123 248.871)",
    className: "st92 st109"
  }, "Account Settings"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 19.4734 264.32)",
    className: "st92 st109"
  }, "Privacy &amp; Social Settings"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M71.8,216H3.8v-11.9c0-1.4,1.2-2.6,2.6-2.6h62.7c1.4,0,2.6,1.2,2.6,2.6V216z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M9,227.5h4.3c1.2,0,2.2-1,2.2-2.2V221c0-1.2-1-2.2-2.2-2.2H9c-1.2,0-2.2,1-2.2,2.2v4.3 C6.7,226.5,7.7,227.5,9,227.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M69.2,230.6H6.4c-1.4,0-2.6-1.1-2.6-2.6v-12h67.9v12C71.8,229.5,70.6,230.6,69.2,230.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M9,252.1h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2H9c-1.2,0-2.2,1-2.2,2.2v4.3 C6.7,251.1,7.7,252.1,9,252.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M71.8,255.2H3.8v-12c0-1.4,1.1-2.6,2.6-2.6h62.8c1.4,0,2.6,1.1,2.6,2.6V255.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M9,266.6h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2H9c-1.2,0-2.2,1-2.2,2.2v4.3 C6.7,265.6,7.7,266.6,9,266.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.8,
    y: 255.2,
    className: "st89",
    width: 67.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 3.8,
    y1: 269.7,
    x2: 71.8,
    y2: 269.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 19.4734 278.8798)",
    className: "st92 st109"
  }, "Notification Settings"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M9,281.2h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2H9c-1.2,0-2.2,1-2.2,2.2v4.3 C6.7,280.2,7.7,281.2,9,281.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.8,
    y: 269.7,
    className: "st89",
    width: 67.9,
    height: 14.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 3.8,
    y1: 284.3,
    x2: 71.8,
    y2: 284.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M65.9,339.7H70v-2c0-1.1-0.9-2-2-2l0,0c-1.1,0-2,0.9-2,2V339.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 68,
    cy: 334.1,
    r: 1.1
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 28.8644 192.184)",
    className: "st92 st93"
  }, "Settings"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M73,328.2H2.7c-1.5,0-2.7,1.2-2.7,2.7v14.6h75.6v-14.6C75.6,329.4,74.4,328.2,73,328.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M24.9,337.3h3c0.2,0,0.4-0.2,0.4-0.4v-3.4c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4 C24.4,337.1,24.6,337.3,24.9,337.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M24.9,341.5h3c0.2,0,0.4-0.2,0.4-0.4v-2.2c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2 C24.4,341.3,24.6,341.5,24.9,341.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M32.8,337.2h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-3.4 C33.2,337.4,33,337.2,32.8,337.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M32.8,333h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-2.2 C33.2,333.2,33,333,32.8,333z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M52.4,333.7h-6.6c-0.3,0-0.6,0.3-0.6,0.6v2.1c0,0.3,0.3,0.6,0.6,0.6h6c0.3,0,0.6-0.3,0.6-0.6V333.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M40.5,336.1H49c0.4,0,0.8,0.4,0.8,0.8v2.7c0,0.4-0.4,0.8-0.8,0.8h-7.8c-0.4,0-0.8-0.4-0.8-0.8V336.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.1,
    y: 333,
    className: "st89",
    width: 8.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st97",
    x1: 46.1,
    y1: 335.3,
    x2: 51.4,
    y2: 335.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 43.3,
    cy: 338.2,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 45.2,
    cy: 338.2,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 47.1,
    cy: 338.2,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M61.9,341.4h5.5v-2.8c0-1.5-1.2-2.8-2.8-2.8h0c-1.5,0-2.8,1.2-2.8,2.8V341.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 64.7,
    cy: 333.7,
    r: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M65.3,194.6h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2h-4.3c-1.2,0-2.2,1-2.2,2.2v4.3 C63.1,193.6,64.1,194.6,65.3,194.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.8,197.2 41.9,198.8 40,200.4 40,197.2 40,193.9 41.9,195.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "41.9,197.2 40,198.8 38.1,200.4 38.1,197.2 38.1,193.9 40,195.5  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6,206.8L63.6,206.8c-0.3,0.3-0.3,0.7,0,1l1.1,1.1c0.3,0.3,0.3,0.7,0,1l-1.1,1.1c-0.3,0.3-0.3,0.7,0,1l0,0 c0.3,0.3,0.7,0.3,1,0l2.1-2.1c0.3-0.3,0.3-0.7,0-1l-2.1-2.1C64.3,206.6,63.8,206.6,63.6,206.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6,221.4L63.6,221.4c-0.3,0.3-0.3,0.7,0,1l1.1,1.1c0.3,0.3,0.3,0.7,0,1l-1.1,1.1c-0.3,0.3-0.3,0.7,0,1l0,0 c0.3,0.3,0.7,0.3,1,0l2.1-2.1c0.3-0.3,0.3-0.7,0-1l-2.1-2.1C64.3,221.1,63.8,221.1,63.6,221.4z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 85.7,
    y: 178.2,
    className: "st90",
    width: 75.6,
    height: 167.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M157.5,209.6v107.6c0,1.4-1.2,2.6-2.6,2.6H92.2c-1.4,0-2.6-1.2-2.6-2.6V209.6c0-1.4,1.2-2.6,2.6-2.6h62.7 C156.3,207,157.5,208.1,157.5,209.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M151.8,339.6h4.1v-2c0-1.1-0.9-2-2-2l0,0c-1.1,0-2,0.9-2,2V339.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 153.8,
    cy: 334,
    r: 1.1
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 110.0304 192.0351)",
    className: "st92 st93"
  }, "Community"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M158.8,328.1H88.5c-1.5,0-2.7,1.2-2.7,2.7v14.6h75.6v-14.6C161.5,329.2,160.3,328.1,158.8,328.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M110.7,337.2h3c0.2,0,0.4-0.2,0.4-0.4v-3.4c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4 C110.3,337,110.4,337.2,110.7,337.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M110.7,341.4h3c0.2,0,0.4-0.2,0.4-0.4v-2.2c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2 C110.3,341.2,110.4,341.4,110.7,341.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M118.6,337.1h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-3.4 C119,337.3,118.8,337.1,118.6,337.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M118.6,332.9h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-2.2 C119,333.1,118.8,332.9,118.6,332.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M138.2,333.6h-6.6c-0.3,0-0.6,0.3-0.6,0.6v2.1c0,0.3,0.3,0.6,0.6,0.6h6c0.3,0,0.6-0.3,0.6-0.6V333.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M126.3,335.9h8.6c0.4,0,0.8,0.4,0.8,0.8v2.7c0,0.4-0.4,0.8-0.8,0.8h-7.8c-0.4,0-0.8-0.4-0.8-0.8V335.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.9,
    y: 332.9,
    className: "st89",
    width: 8.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M151.1,194.4h4.3c1.2,0,2.2-1,2.2-2.2V188c0-1.2-1-2.2-2.2-2.2h-4.3c-1.2,0-2.2,1-2.2,2.2v4.3 C148.9,193.4,149.9,194.4,151.1,194.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st97",
    x1: 132,
    y1: 335.1,
    x2: 137.2,
    y2: 335.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 129.1,
    cy: 338.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 131,
    cy: 338.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 132.9,
    cy: 338.1,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M147.8,341.2h5.5v-2.8c0-1.5-1.2-2.8-2.8-2.8h0c-1.5,0-2.8,1.2-2.8,2.8V341.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 150.5,
    cy: 333.6,
    r: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 90.8477 204.3644)",
    className: "st92 st109"
  }, "Christmas Party"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 94.914 215.8561)",
    className: "st92 st109"
  }, "What?!"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 94.914 230.3442)",
    className: "st92 st109"
  }, "When"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 94.914 243.5204)",
    className: "st92 st109"
  }, "Where?"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 93.4112 256.1003)",
    className: "st92 st109"
  }, "Contribution selection!"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 93.3842 288.8786)",
    className: "st92 st109"
  }, "current contributions!"), /*#__PURE__*/React.createElement("rect", {
    x: 108.4,
    y: 213.4,
    className: "st99",
    width: 42.8,
    height: 10.3
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 108.3684 215.5148)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st100 st98"
  }, "Description of event for the "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2.9,
    className: "st100 st98"
  }, "community.")), /*#__PURE__*/React.createElement("rect", {
    x: 108.4,
    y: 228,
    className: "st99",
    width: 42.8,
    height: 10.3
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 108.3684 230.0478)",
    className: "st100 st98"
  }, "Friday, December 19th 2022"), /*#__PURE__*/React.createElement("rect", {
    x: 108.4,
    y: 241.3,
    className: "st99",
    width: 42.8,
    height: 10.3
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 108.3684 243.3674)",
    className: "st100 st98"
  }, "Main Office Lobby"), /*#__PURE__*/React.createElement("rect", {
    x: 96.3,
    y: 279.3,
    className: "st99",
    width: 11.5,
    height: 3.4
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 96.3278 281.3346)",
    className: "st100 st98"
  }, "Appetizer"), /*#__PURE__*/React.createElement("rect", {
    x: 93.4,
    y: 290.8,
    className: "st99",
    width: 25.6,
    height: 3.4
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 93.3901 292.1525)",
    className: "st100 st101"
  }, "Sally: bonesless wngs"), /*#__PURE__*/React.createElement("rect", {
    x: 93.4,
    y: 293.3,
    className: "st99",
    width: 25.6,
    height: 3.4
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 93.3901 294.714)",
    className: "st100 st101"
  }, "Sally: chips and salsa"), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 291,
    className: "st99",
    width: 25.6,
    height: 2.3
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 116.9588 292.4052)",
    className: "st100 st101"
  }, "Sally: crockpot chili"), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 293.6,
    className: "st99",
    width: 25.6,
    height: 2.3
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 116.9588 294.9457)",
    className: "st100 st101"
  }, "Sally: chicken sliders"), /*#__PURE__*/React.createElement("rect", {
    x: 138.3,
    y: 291,
    className: "st99",
    width: 25.6,
    height: 2.3
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 138.3465 292.4052)",
    className: "st100 st101"
  }, "Sally: brownies"), /*#__PURE__*/React.createElement("rect", {
    x: 138.3,
    y: 293.6,
    className: "st99",
    width: 25.6,
    height: 3.9
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 138.3465 294.9457)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st100 st101"
  }, "Sally: chocolate chip "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 1.9,
    className: "st100 st101 st113"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 2.4,
    y: 1.9,
    className: "st100 st101"
  }, "    cookies")), /*#__PURE__*/React.createElement("rect", {
    x: 120.4,
    y: 279.3,
    className: "st99",
    width: 11.5,
    height: 3.4
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 120.4473 281.3346)",
    className: "st100 st98"
  }, "Entree"), /*#__PURE__*/React.createElement("rect", {
    x: 141.1,
    y: 279.3,
    className: "st99",
    width: 11.5,
    height: 3.4
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 141.1299 281.3346)",
    className: "st100 st98"
  }, "Dessert"), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M108.6,277H95.5c-1.2,0-2.1-0.9-2.1-2.1v-13.1c0-1.2,0.9-2.1,2.1-2.1h13.1c1.2,0,2.1,0.9,2.1,2.1v13.1 C110.7,276,109.8,277,108.6,277z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M130.2,277h-13.1c-1.2,0-2.1-0.9-2.1-2.1v-13.1c0-1.2,0.9-2.1,2.1-2.1h13.1c1.2,0,2.1,0.9,2.1,2.1v13.1 C132.3,276,131.4,277,130.2,277z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M151.8,277h-13.1c-1.2,0-2.1-0.9-2.1-2.1v-13.1c0-1.2,0.9-2.1,2.1-2.1h13.1c1.2,0,2.1,0.9,2.1,2.1v13.1 C153.9,276,152.9,277,151.8,277z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 89.6,
    y1: 307.5,
    x2: 157.5,
    y2: 307.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st89",
    x1: 123.6,
    y1: 307.5,
    x2: 123.6,
    y2: 319.8
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 133.1681 314.7841)",
    className: "st92 st109"
  }, "Attending"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 95.0653 314.7841)",
    className: "st92 st109"
  }, "Not Attending"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M91.9,194.4h4.3c1.2,0,2.2-1,2.2-2.2V188c0-1.2-1-2.2-2.2-2.2h-4.3c-1.2,0-2.2,1-2.2,2.2v4.3 C89.7,193.4,90.7,194.4,91.9,194.4z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st104",
    points: "96.6,190.1 92.5,190.1 94.3,188.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st104",
    x1: 92.5,
    y1: 190.1,
    x2: 94.1,
    y2: 191.7
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 259.7,
    y: 178.2,
    className: "st90",
    width: 75.6,
    height: 167.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M329.1,216.5h-62.8c-1.4,0-2.6-1.1-2.6-2.6v-9.4c0-1.4,1.2-2.6,2.6-2.6H329c1.4,0,2.6,1.2,2.6,2.6v9.4 C331.6,215.4,330.5,216.5,329.1,216.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M327,214.5H314c-1.4,0-2.6-1.1-2.6-2.6v-5.4c0-1.4,1.2-2.6,2.6-2.6h13c1.4,0,2.6,1.2,2.6,2.6v5.4 C329.6,213.4,328.4,214.5,327,214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M329.1,242.1h-62.8c-1.4,0-2.6-1.1-2.6-2.6v-34.9c0-1.4,1.2-2.6,2.6-2.6H329c1.4,0,2.6,1.2,2.6,2.6v34.9 C331.6,240.9,330.5,242.1,329.1,242.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M325.7,339.5h4.1v-2c0-1.1-0.9-2-2-2l0,0c-1.1,0-2,0.9-2,2V339.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 327.7,
    cy: 333.9,
    r: 1.1
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 293.1865 191.9994)",
    className: "st92 st93"
  }, "Pay"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M332.7,328h-70.3c-1.5,0-2.7,1.2-2.7,2.7v14.6h75.6v-14.6C335.4,329.2,334.2,328,332.7,328z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M284.6,337.1h3c0.2,0,0.4-0.2,0.4-0.4v-3.4c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4 C284.2,336.9,284.4,337.1,284.6,337.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M284.6,341.4h3c0.2,0,0.4-0.2,0.4-0.4v-2.2c0-0.2-0.2-0.4-0.4-0.4h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2 C284.2,341.2,284.4,341.4,284.6,341.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M292.5,337h-3c-0.2,0-0.4,0.2-0.4,0.4v3.4c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-3.4 C292.9,337.2,292.7,337,292.5,337z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M292.5,332.8h-3c-0.2,0-0.4,0.2-0.4,0.4v2.2c0,0.2,0.2,0.4,0.4,0.4h3c0.2,0,0.4-0.2,0.4-0.4v-2.2 C292.9,333,292.7,332.8,292.5,332.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M312.1,333.5h-6.6c-0.3,0-0.6,0.3-0.6,0.6v2.1c0,0.3,0.3,0.6,0.6,0.6h6c0.3,0,0.6-0.3,0.6-0.6V333.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M300.2,335.9h8.6c0.4,0,0.8,0.4,0.8,0.8v2.7c0,0.4-0.4,0.8-0.8,0.8H301c-0.4,0-0.8-0.4-0.8-0.8V335.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.8,
    y: 332.8,
    className: "st89",
    width: 8.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M325,194.4h4.3c1.2,0,2.2-1,2.2-2.2v-4.3c0-1.2-1-2.2-2.2-2.2H325c-1.2,0-2.2,1-2.2,2.2v4.3 C322.8,193.4,323.8,194.4,325,194.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st97",
    x1: 305.9,
    y1: 335.1,
    x2: 311.1,
    y2: 335.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 303,
    cy: 338.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 304.9,
    cy: 338.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 306.8,
    cy: 338.1,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M321.7,341.2h5.5v-2.8c0-1.5-1.2-2.8-2.8-2.8l0,0c-1.5,0-2.8,1.2-2.8,2.8V341.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 324.4,
    cy: 333.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 268.3383 220.3114)",
    className: "st92 st109"
  }, "Breakdown"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 268.6029 225.1271)",
    className: "st114 st98"
  }, "Base Rent: $1200"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 268.771 229.1862)",
    className: "st114 st98"
  }, "Gas: $58"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 268.771 233.2455)",
    className: "st114 st98"
  }, "Electric: $35"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 268.771 237.3046)",
    className: "st114 st98"
  }, "Water: $35"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 266.8338 210.8796)",
    className: "st92 st115"
  }, "Total Due"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 315.0192 208.0727)",
    className: "st92 st116"
  }, "Autopay"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 318.3516 212.1532)",
    className: "st92 st116"
  }, "ON"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 289.5133 210.8796)",
    className: "st92 st115"
  }, "$1385.82"), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M329.1,260.2h-62.8c-1.4,0-2.6-1.1-2.6-2.6v-9.4c0-1.4,1.2-2.6,2.6-2.6H329c1.4,0,2.6,1.2,2.6,2.6v9.4 C331.6,259.1,330.5,260.2,329.1,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M329.1,285.8h-62.8c-1.4,0-2.6-1.1-2.6-2.6v-34.9c0-1.4,1.2-2.6,2.6-2.6H329c1.4,0,2.6,1.2,2.6,2.6v34.9 C331.6,284.6,330.5,285.8,329.1,285.8z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 268.3383 264.2751)",
    className: "st92 st109"
  }, "Breakdown"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 268.4518 268.809)",
    className: "st114 st98"
  }, "Base Rent: $1200"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 268.6501 272.8686)",
    className: "st114 st98"
  }, "Gas: $58"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 268.771 276.9274)",
    className: "st114 st98"
  }, "Electric: $50"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 268.771 280.9865)",
    className: "st114 st98"
  }, "Water: $35"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 268.6029 254.5614)",
    className: "st92 st115"
  }, "Last Month"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 305.1131 254.5614)",
    className: "st92 st115"
  }, "$1405.82"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 562.7,
    y: 8.4,
    className: "st12",
    width: 153.2,
    height: 331.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.1
    },
    width: 153,
    height: 130,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJoAAACDCAYAAAB1JgJEAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABBZJREFUeNrs2E1vE1cYhuF44nyW JHy1pYt20S5gyf//FSyJhFS1IEhRadIEgpPYmDPpM+mJGTthU6nydUuvYuIZFtGl94w9WLlFT54+ XpH6ev5s/1bXDW6Ja7DoWi1t08yN4AYLkA2qaWBTD7B2Pt0G3GABstXMsMxafjbVPdAtJ7CV4BqX uchManB92AY9yJoAWy+zVeabzGbA2W42WYvsY5kPZd7n9Xl+34tt0INsGFS7Ze6XeVjmQf69mfdt tOWF1m6uszInZd6VeZufJwE37rZbjW3Qc1y2W+xemR/K/FTmx7y+l/e6I1TLC60FdVTmTZnfyrws c1DmsMxpjtNrm63eTk2OxvaY/K7ML2Ue52cLbS8bbdXRudTQJjkmW2iPytwtsx0X0+p5bVzfOKxe N3ku2wusn9tll58PA3At/6E8o92Ple04aoGNMt0HhOkVtOrYbLKx9iK1OzYf5flso9pmcnxuZDGt BtZxntUO8wHh8vgsvi6Pz2F1DK7m5t1ssG+j9k71IQAydadf9+3DJMi+z3P8dk6+Ud6f9h2dwzzw t7h28rpT6wOA6lYDaitWduOm9+Rr5tzcrcX6ezPp2rcV1XJar8wM+8w0Mzc3M+PTpW4CN8/NyqKN NisWMn0NuIUPddJ/8ulBAk2gSaAJNIEmgSbQJNAEmkCTQBNoEmgCTaBJoAk0CTSBJtAk0ASaQJNA E2gSaAJNoEmgCTQJNIEm0CTQBJoEmkATaBJoAk0CTaAJNAk0gSbQJNAEmgSaQBNoEmgCTQJNoAk0 CTSBJoEm0ASaBJpAk0ATaAJNAk2gCTR/AoEm0CTQBJpAk0ATaBJoAk2gSaAJNAk0gSbQJNAEmgSa QBNoEmgCTQJNoAk0CTSBJtAk0ASaBJr+J9Cm/kS6RdOb3DQ9F7TzCTJ9BbLOTDcLN1p38aTMODOZ d6NUebnIjOctqVlo7YVnZT5mzhbdrKXeYt1CGpX5UOakzGmZ87x3zctw5sbz3HSUaW/eqa7z4UHd JruIlcMybzOHwTaujtR/oD1/tj998vRxd3O7wf7OTa/LPCizmWs3Aw4222ycE+9dmVdlfi3ze9y8 D8LLU7D4urbRamjtJnuTm7fz3iibbaPMan438DdfSmSdk+M4eVFmP17+mIH2xdHZQTvPcXkQVCtZ ha3cu2W2cg9ky9ski+evbLMXmZdZUqPZbXYFrTo+J1mJf0bvWc7dVz3QYFvejTaKi4MAex14p9WH x2tdw1KwDXI0rgXVToDtlrlTZr3agqAtL7SLHJFHAXecBXXRt816sQRbE3DrOUI3KmQNaEsNrf6G YpRT72zl3+9cv0A2F0uwdeCaCp4jU9PqmX5SA5uHbOFWCrb6OsA0b8PNBXYjtAXopCtoNwHr+izA AN/PLWyhfkj4AAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 563.269 42.2616)"
  }), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M702,166h-127c-4,0-7.3-3.3-7.3-7.3V54.2c0-4,3.3-7.3,7.3-7.3h127c4,0,7.3,3.3,7.3,7.3v104.5 C709.3,162.7,706,166,702,166z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M701.9,296.5h-127c-4.1,0-7.3-3.3-7.3-7.3V183.9c0-4.1,3.3-7.3,7.3-7.3h127c4.1,0,7.3,3.3,7.3,7.3v105.2 C709.3,293.2,706,296.5,701.9,296.5z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 614.3659 40.703)",
    className: "st92 st118"
  }, "Dashboard")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 576.7757 187.0636)",
    className: "st92 st119"
  }, "Upcoming Payment")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 576.6453 60.1662)",
    className: "st92 st119"
  }, "While you were Away..")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 588.9633 97.1567)",
    className: "st92 st120"
  }, "Nothing Happened!")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M699.7,232l-121-0.8c-2.9,0-5.3-2.4-5.3-5.3v-28.8c0-2.9,2.4-5.3,5.3-5.3l121,0.8c2.9,0,5.3,2.4,5.3,5.3 v28.8C705,229.6,702.6,232,699.7,232z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M699.7,288l-121-0.8c-2.9,0-5.3-2.4-5.3-5.3v-28.8c0-2.9,2.4-5.3,5.3-5.3l121,0.8c2.9,0,5.3,2.4,5.3,5.3 v28.8C705,285.6,702.6,288,699.7,288z"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 576.7757 244.6003)",
    className: "st92 st119"
  }, "Events")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 599.9724 211.9797)",
    className: "st92 st119"
  }, "Rent")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 618.03 202.2531)",
    className: "st92 st119"
  }, "Due: 4/20/2022")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 597.8527 218.5234)",
    className: "st100 st121"
  }, "$1100.99")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 631.8436 211.9797)",
    className: "st92 st119"
  }, "Utilites")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 633.8122 218.5234)",
    className: "st100 st121"
  }, "213.43")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 665.2785 212.206)",
    className: "st92 st119"
  }, "Amenities")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 673.9388 218.0143)",
    className: "st100 st121"
  }, "59.00")), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M725,79.8V25.2C725,11.3,713.7,0,699.8,0H578.5c-13.9,0-25.2,11.3-25.2,25.2v21.4h-0.8V60h0.8v11.3 c-0.5,0.4-0.9,1-0.9,1.7v22.5c0,0.7,0.3,1.3,0.9,1.7v6.3c-0.5,0.4-0.9,1-0.9,1.7v22.5c0,0.7,0.3,1.3,0.9,1.7V323 c0,13.9,11.3,25.2,25.2,25.2h121.2c13.9,0,25.2-11.3,25.2-25.2V120.5c0.6-0.1,1.1-0.7,1.1-1.3V81.1 C726.1,80.5,725.6,79.9,725,79.8z M715.6,323.4c0,9-7.3,16.2-16.2,16.2H578.9c-9,0-16.2-7.3-16.2-16.2V25.3 c0-9,7.3-16.2,16.2-16.2h15.6c1.2,0.1,2.1,1,2.1,2.1v1.4c0,4.7,3.8,8.5,8.5,8.5h68c4.7,0,8.5-3.8,8.5-8.5v-1.3h0 c0-1.2,0.9-2.2,2.1-2.2h15.7c9,0,16.2,7.3,16.2,16.2V323.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.3,1.9h-122c-12.5,0-22.6,10.1-22.6,22.6v299.2c0,12.5,10.1,22.6,22.6,22.6h122c12.5,0,22.6-10.1,22.6-22.6V24.5 C722.9,12,712.8,1.9,700.3,1.9z M715.6,323.4c0,9-7.3,16.2-16.2,16.2H578.9c-9,0-16.2-7.3-16.2-16.2V25.3 c0-9,7.3-16.2,16.2-16.2h15.6c1.2,0.1,2.1,1,2.1,2.1v1.4c0,4.7,3.8,8.5,8.5,8.5h68c4.7,0,8.5-3.8,8.5-8.5v-1.3h0 c0-1.2,0.9-2.2,2.1-2.2h15.7c9,0,16.2,7.3,16.2,16.2V323.4z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M685.3,318.2v10h1.5c0.6,0,1.1,0.5,1.1,1.1v1.4h2.6v-2.5c0-0.2,0.2-0.4,0.4-0.4h1.3v2.9h0.5v-2.9h1.3 c0.2,0,0.4,0.2,0.4,0.4v2.5h4.4V330c-0.3-0.2-0.5-0.5-0.5-0.9c0-0.3,0.1-0.6,0.3-0.8c-0.1-0.1-0.1-0.3-0.1-0.5 c0-0.5,0.4-0.9,0.9-0.9c0.1,0,0.2,0,0.3,0v-8.8H685.3z M689.2,325.4c0,0.2-0.2,0.4-0.4,0.4h-1.4c-0.2,0-0.4-0.2-0.4-0.4v-1.9 c0-0.2,0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4V325.4z M689.2,321.7c0,0.2-0.2,0.4-0.4,0.4h-1.4c-0.2,0-0.4-0.2-0.4-0.4 v-1.9c0-0.2,0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4V321.7z M691.4,319.8c0-0.2,0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4 v1.9c0,0.2-0.2,0.4-0.4,0.4h-1.4c-0.2,0-0.4-0.2-0.4-0.4V319.8z M694,327.4h-3.1c-0.2,0-0.4-0.2-0.3-0.3c0.2-0.7,1-1.3,1.9-1.3 c0.9,0,1.7,0.6,1.9,1.3C694.3,327.2,694.2,327.4,694,327.4z M697.7,325.4c0,0.2-0.2,0.4-0.4,0.4H696c-0.2,0-0.4-0.2-0.4-0.4 v-1.9c0-0.2,0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4V325.4z M697.7,321.7c0,0.2-0.2,0.4-0.4,0.4H696c-0.2,0-0.4-0.2-0.4-0.4 v-1.9c0-0.2,0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4V321.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M700.3,317.7h-15.8c-0.5,0-0.7-0.5-0.3-0.7l0.9-0.6c0.1-0.1,0.2-0.1,0.3-0.1h14c0.1,0,0.2,0,0.3,0.1 l0.9,0.6C701,317.2,700.8,317.7,700.3,317.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M687.4,329.2v1.4h-2.8v-1.4c0-0.3,0.3-0.6,0.6-0.6h1.5C687.1,328.6,687.4,328.9,687.4,329.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M699.6,330.1v0.5h-0.5v-0.5c0.1,0,0.2,0,0.3,0C699.4,330.2,699.5,330.1,699.6,330.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M700.2,329.1c0,0.3-0.1,0.5-0.3,0.7c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.2,0-0.3,0 s-0.2,0-0.3,0c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.2,0.1-0.5,0.3-0.6 c0.2,0.2,0.4,0.2,0.6,0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.3-0.1,0.4-0.2C700.1,328.6,700.2,328.8,700.2,329.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M700,327.8c0,0.1,0,0.2-0.1,0.3c0,0,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1 c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0-0.3-0.1-0.4-0.2c0,0-0.1-0.1-0.1-0.1s0-0.1-0.1-0.1c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.4,0.3-0.7,0.7-0.7c0.1,0,0.2,0,0.3,0.1C699.8,327.3,700,327.5,700,327.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 603.5671,
    cy: 321.2676,
    r: 24.2781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDB44D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#E97B00"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M613.1,325.2h4.8c0.8,0,1.5,0.7,1.5,1.5v3.1c0,0.8-0.7,1.5-1.5,1.5h-4.8c-0.8,0-1.5-0.7-1.5-1.5v-3.1 C611.6,325.9,612.3,325.2,613.1,325.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000002360357531231181010000004969099411768730811_",
    cx: 603.5671,
    cy: 321.2676,
    r: 24.2781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDB44D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#E97B00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002360357531231181010000004969099411768730811_)"
    },
    d: "M613.4,315h4.2c1,0,1.8,0.8,1.8,1.8 v5.3c0,1-0.8,1.8-1.8,1.8h-4.2c-1,0-1.8-0.8-1.8-1.8v-5.3C611.6,315.9,612.4,315,613.4,315z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000091713188908462849550000006552407276552487860_",
    cx: 603.5671,
    cy: 321.2676,
    r: 24.2781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDB44D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#E97B00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091713188908462849550000006552407276552487860_)"
    },
    d: "M627.4,321.2h-4.8 c-0.8,0-1.5-0.7-1.5-1.5v-3.1c0-0.8,0.7-1.5,1.5-1.5h4.8c0.8,0,1.5,0.7,1.5,1.5v3.1C628.9,320.5,628.2,321.2,627.4,321.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000020390366344156212010000005932804383788081043_",
    cx: 603.5671,
    cy: 321.2676,
    r: 24.2781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDB44D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#E97B00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020390366344156212010000005932804383788081043_)"
    },
    d: "M627.1,331.4h-4.2 c-1,0-1.8-0.8-1.8-1.8v-5.3c0-1,0.8-1.8,1.8-1.8h4.2c1,0,1.8,0.8,1.8,1.8v5.3C628.9,330.6,628.1,331.4,627.1,331.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000080904951448105096540000003243552987427115394_",
    cx: 645.9915,
    cy: 309.3857,
    r: 21.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22B573"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#83CC79"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080904951448105096540000003243552987427115394_)"
    },
    d: "M652.4,319.8 c-0.9,0.9-1.5,2.2-1.5,3.5h-1.7c-0.1,0-0.2,0.1-0.2,0.2v1.8c0,0.2-0.2,0.3-0.4,0.1l-2.8-3.2l0,0c-0.5-0.6-0.9-1.4-0.9-2.3 c0-1.8,1.5-3.2,3.3-3.2h4.8c0.9,0,1.7,0.4,2.3,1c0.2,0.2,0.3,0.4,0.4,0.5c0,0,0,0,0,0C654.6,318.3,653.4,318.9,652.4,319.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000022556371814096544120000014642044402513879459_",
    cx: 645.9915,
    cy: 309.3857,
    r: 21.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22B573"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#83CC79"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022556371814096544120000014642044402513879459_)"
    },
    d: "M662.3,319.1H656 c-1.2,0-2.3,0.5-3,1.3c-0.8,0.8-1.2,1.8-1.3,3v0c0,2.4,1.9,4.3,4.3,4.3h5.1c0.2,0,0.3,0.1,0.3,0.3v2.3c0,0.3,0.3,0.4,0.5,0.2 l3.6-4.2l0,0c0.7-0.8,1.1-1.8,1.1-3C666.6,321,664.6,319.1,662.3,319.1z M656.5,324.4c-0.5,0-1-0.4-1-1s0.4-1,1-1 c0.5,0,1,0.4,1,1S657,324.4,656.5,324.4z M659.2,324.4c-0.5,0-1-0.4-1-1s0.4-1,1-1c0.5,0,1,0.4,1,1S659.7,324.4,659.2,324.4z  M661.9,324.4c-0.5,0-1-0.4-1-1s0.4-1,1-1c0.5,0,1,0.4,1,1S662.4,324.4,661.9,324.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000047039785352277859610000007301135583006505648_",
    cx: 567.5209,
    cy: 313.0345,
    r: 21.8712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0000FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#2E67CE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047039785352277859610000007301135583006505648_)"
    },
    d: "M583.1,322.8c0,1.1-0.5,2.1-1.3,2.7 h-0.7v-2.7c0-0.8-0.7-1.5-1.5-1.5c-0.8,0-1.5,0.7-1.5,1.5v3.2c-1.3-0.5-2.2-1.8-2.2-3.3c0-2,1.6-3.6,3.6-3.6 C581.5,319.2,583.1,320.8,583.1,322.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000171678169942362851740000002909106681543857294_",
    cx: 567.5209,
    cy: 313.0345,
    r: 21.8712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0000FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#2E67CE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171678169942362851740000002909106681543857294_)"
    },
    d: "M579.5,314.5c-4.6,0-8.3,3.7-8.3,8.3 c0,4.1,3,7.5,6.9,8.2c0-0.1,0-0.2,0-0.2v0l-0.4-1.3c-2.9-0.8-5-3.4-5-6.6c0-3.8,3.1-6.8,6.8-6.8c3.8,0,6.8,3.1,6.8,6.8 c0,1.7-0.6,3.3-1.7,4.5c0,0,0,0.1,0,0.1v0l-0.2,2c2.1-1.5,3.4-3.9,3.4-6.7C587.9,318.2,584.1,314.5,579.5,314.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000090258569249298984520000006484519670784877957_",
    cx: 567.5209,
    cy: 313.0345,
    r: 21.8712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0000FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#2E67CE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090258569249298984520000006484519670784877957_)"
    },
    d: "M583.9,327.4l-0.1,0.7l-0.2,1.9 l-0.1,0.7c0,0.6-0.5,1.1-1.1,1.1H580c-0.5,0-0.9-0.3-1.1-0.8c0-0.1-0.1-0.2-0.1-0.3v-0.2l-0.3-1l-0.5-1.6c0-0.1,0-0.2,0-0.3 c0-0.4,0.2-0.7,0.6-0.8c0.1,0,0.2,0,0.2,0v-4c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v3.4h2.5 C583.4,326.3,583.9,326.8,583.9,327.4z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M587.3,215.2h-7.1c-1.7,0-3.1-1.4-3.1-3.1v-3.9c0-1.7,1.4-3.1,3.1-3.1h7.1c1.7,0,3.1,1.4,3.1,3.1v3.9 C590.3,213.8,589,215.2,587.3,215.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "585.1,214.3 583.7,213.2 582.3,214.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M589.3,207.8h-5.3v1.1h-2v2.2h3.7v-1.8h3.7v-0.8C589.4,208.3,589.4,208.1,589.3,207.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.4,
    y: 210.1,
    className: "st39",
    width: 3,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M583.9,207.1h5.1c-0.5-0.7-1.2-1.1-2.1-1.1h-4.1L583.9,207.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M583.3,208.2v-0.6l-1.6-1.6h-1.2c-1.3,0-2.4,1-2.6,2.2H583.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M584.1,211.9v0.6l2.1,1.8h0.6c1.4,0,2.5-1,2.6-2.4H584.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M581.2,214.3l2.2-1.8v-0.6H578c0.1,1.3,1.2,2.4,2.6,2.4H581.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578,
    y: 209,
    className: "st39",
    width: 3.4,
    height: 2.2
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M593.3,276.5v-4.1c0-0.3-0.2-0.5-0.5-0.5h-4.2c-0.3,0-0.5,0.2-0.5,0.5v4.1c0,0.3,0.2,0.5,0.5,0.5h4.2 C593.1,277.1,593.3,276.8,593.3,276.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M599.6,263.6v-1.6c0-1.6-1.3-2.9-2.9-2.9h-12.2c-1.6,0-2.9,1.3-2.9,2.9v1.6c0,0.3,0.2,0.5,0.5,0.5h16.8 C599.4,264.2,599.6,263.9,599.6,263.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M588,265.8v4.4c0,0.3,0.2,0.5,0.5,0.5h4.2c0.3,0,0.5-0.2,0.5-0.5v-4.4c0-0.3-0.2-0.5-0.5-0.5h-4.2 C588.3,265.3,588,265.5,588,265.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M599.1,265.3h-4.2c-0.3,0-0.5,0.2-0.5,0.5v4.4c0,0.3,0.2,0.5,0.5,0.5h4.2c0.3,0,0.5-0.2,0.5-0.5v-4.4 C599.6,265.5,599.4,265.3,599.1,265.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M594.4,272.4v4.1c0,0.3,0.2,0.5,0.5,0.5h1.8c1.6,0,2.9-1.3,2.9-2.9v-1.8c0-0.3-0.2-0.5-0.5-0.5h-4.2 C594.6,271.8,594.4,272.1,594.4,272.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M582.3,270.8h4.2c0.3,0,0.5-0.2,0.5-0.5v-4.4c0-0.3-0.2-0.5-0.5-0.5h-4.2c-0.3,0-0.5,0.2-0.5,0.5v4.4 C581.7,270.5,582,270.8,582.3,270.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M586.4,271.8h-4.2c-0.3,0-0.5,0.2-0.5,0.5v1.8c0,1.6,1.3,2.9,2.9,2.9h1.8c0.3,0,0.5-0.2,0.5-0.5v-4.1 C587,272.1,586.7,271.8,586.4,271.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M585.7,261.8c-0.6,0-1.1-0.5-1.1-1.1v-1.8c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v1.8 C586.8,261.3,586.3,261.8,585.7,261.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M585.2,260.6v-1.8c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v1.8c0,0.3-0.2,0.5-0.5,0.5l0,0 C585.4,261.2,585.2,260.9,585.2,260.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M590.7,261.8c-0.6,0-1.1-0.5-1.1-1.1v-1.8c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1v1.8 C591.8,261.3,591.3,261.8,590.7,261.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M590.1,260.6v-1.8c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v1.8c0,0.3-0.2,0.5-0.5,0.5l0,0 C590.4,261.2,590.1,260.9,590.1,260.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M595.6,261.8c-0.6,0-1.1-0.5-1.1-1.1v-1.8c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1v1.8 C596.7,261.3,596.2,261.8,595.6,261.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M595.1,260.6v-1.8c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v1.8c0,0.3-0.2,0.5-0.5,0.5l0,0 C595.3,261.2,595.1,260.9,595.1,260.6z"
  }))))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st133",
    points: "660.8,150 667,137.1 673.1,150  "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st133",
    points: "667,137.1 666.9,115.8 660.8,125.4 636.1,143.6  "
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st133",
    x1: 666.9,
    y1: 115.8,
    x2: 670.2,
    y2: 126.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st133",
    cx: 666.9,
    cy: 111.4,
    r: 4.4
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st133",
    points: "653.4,152.4 640.5,146.2 653.4,140.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st133",
    points: "640.5,146.2 619.2,146.3 628.8,152.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st133",
    x1: 619.2,
    y1: 146.3,
    x2: 629.8,
    y2: 143.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st133",
    cx: 614.7,
    cy: 146.3,
    r: 4.4
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st134",
    x1: 665.3,
    y1: 112.7,
    x2: 666.3,
    y2: 112.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 665.5,
    cy: 110.5,
    r: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 668,
    cy: 110.5,
    r: 0.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st117",
    cx: 665.3,
    cy: 110.5,
    r: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st117",
    cx: 667.8,
    cy: 110.5,
    r: 0.1
  }))), /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 367.4,
    y: 8.4,
    className: "st12",
    width: 153.2,
    height: 331.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.1
    },
    width: 152,
    height: 130,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJkAAACDCAYAAACeEblHAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABEZJREFUeNrsmctO21AURW3HJEBS Xn1QtUV0UsGQ//8KhiAhtaKIAuX9Dklwz632TQ/GJAxgUq8lbQg3dgZoaZ/rmzR5BqtrKwlAFRvr m2OvSZ8pVjrqWqgthTJStnSEYKlLhmhQIVfI/TjZ0ifaK6w3lNwyod+Zuwfh6ilXIrH6lp4y8LKV RUsr2itTmpYpS1uZlGy0Gg0WBLuxXCrh9Z1keyRaXhIu01oQasayYHmrzGg9p8lqLVlorK7l3HJo 2dfvC60PVFpD0fJSizXUXvOWT5YvliXLotam3NiE+koWmuvEsmP54SbcmROtKDdZbLGWZdby2fJN +SrJZtVkDcZlrSUbSKQg2TttpRpur1bo/SK2We5aLFdThdG4HApOWdLYbOuaBv/r2u/JeppsbbVY Ivl62q/1nXB/pUmdZG3ZuaQGW1aLdfRhDRoM0SRUy03CINeV9mnxQWAQ2yxelEmijppsUVnQWgvB wBFPGGbVWlfa/O9a9iynGpnhmiIv7cc6Eiu02Zxl2jUYm33w5Gq1jkbnvE4gptyEfLDxDxI1dcOc DG1rDcGgTOq8mVBBTboR6g/th/LEcRkPX6cZkfBM2fy3Q5W+eOPiQWxTeWQkwAjR0tLfSbnJ/NdJ WcJXR/DCTwlPzVsEg1eTDADJAMkAkAyQDJAMAMkAyQDJAJAMkAwAyQDJAMkAkAyQDJAMAMkAyQCQ DJAMkAwAyQDJAMkAkAyQDADJAMkAyQCQDJAMkAwAyQDJAJAMkAyQDADJAMkAyQCQDJAMAMkAyQDJ AJAMkAyQDADJAMkAkAyQDJAMAMkAyQDJAJAMkAwAyQDJAMkAkAyQDJAMAMkAyQCQDJAMkAwAyQDJ AMkAkAyQDADJAMkAyQCQDJAMAMkAyQDJAJAMkAyQDADJAMkAkAyQDJAMAMkAyQDJAJAMkAwAyQDJ 4P+XrODfAy8tWaHcIxi8hmRRroGlrwy0BjCOYtTfmWuwINWd5dbStfRoNXimYLGk7quKKTZZFOzK cqHcIBqMIU6/ntKv8iVzFgbJLi3HlhOJdvvUjVD79opbq1tXTtfyaOB9yZ2RXSfZgeXIMm9pWVJd y5EHRF96kutEvhzo9bXki2P0gWR9SXZo2bV8sHQsDZk5qdeIRov1tZ0KRbRj+W7ZlmiXfpu1sb6Z 5PajWF1bSXTjtSTbdoKF+ntveWNpai1Ru0H9BItT79zyy7Jl2ZRo+yXJHozLuPm/VeVtq7HCh51Z PlrmLFO6B8HqS/TkWC22pfy0nOq9YYsNJVObxTl7qQ+L4/O3RmdZMkSrb5PFMtqTXLuS7to9KCZV TeYfAPzG7kgf1NG4zBmXtZcsltGpZDtPSkdescUeiWJtlrqjjYakainN0hMmktVTsqqD+27y7xui B4I9KYpkSyVU5qRjTELhpt7Ay1Ul2Mg2cq2WIBeMabZKucZKNkI4gKFko+SK/BFgAG7QRe7g0//m AAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 368.269 42.2616)"
  }), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M506.7,166h-127c-4,0-7.3-3.3-7.3-7.3V54.2c0-4,3.3-7.3,7.3-7.3h127c4,0,7.3,3.3,7.3,7.3v104.5 C514.1,162.7,510.8,166,506.7,166z"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M506.7,296.5h-127c-4.1,0-7.3-3.3-7.3-7.3V183.9c0-4.1,3.3-7.3,7.3-7.3h127c4.1,0,7.3,3.3,7.3,7.3v105.2 C514.1,293.2,510.8,296.5,506.7,296.5z"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 419.1453 40.703)",
    className: "st92 st118"
  }, "Dashboard")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 381.5551 187.0636)",
    className: "st92 st119"
  }, "Upcoming Payment")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 381.4246 60.1662)",
    className: "st92 st119"
  }, "While you were Away..")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.05
    },
    width: 145,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJIAAAApCAYAAADednA4AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAylJREFUeNrsnEtv00AUhSe2kyaU AikPIUAg2LTL/v9f0WW75SVoC21Ik4aktrlXOZNcxnZIpS7Q+BzpyMk49iafzp1JfMc5iroHdTad PDw62PqzVJQq/YuT49O7g2QA6hgTqPYBZI/lJqA6GwBKAvsxqh0gqYvAjUBlNWCpU5zrins4ZoSp VRDl4lvxHL6FC1vyKomENOoAGIVnIH4IPxDvALCEJS76kqYQLcQ34on4GseZhcmmUhZAlSJ9FJx9 8XPxM/ETjHVNmaPihUlh+S0ei3+Iz8UXOD8DZGUlkZBGiYHoqfi1+J34DYDaQ1KlBClqFQBJ0+hS /FX8UfxJ/F08AmS5TaUsmBtlKGlD8SvxB/F78UvxI4DERGoPSD8xtfFJNMH4Ipwr1ZU2Bemx+AVS 6S1A2jOljYq7tOUAZhdj1yhxF0ikm/CiLFjup0idXcyL9uEhxjJX/V2Jig+kAosrhxQaIkgGYCAx HJR1y/8EY3qTPuZLA7zvGZCouJXjODDuoyLVzpGzmp8CEgOUd2rGqfiVAqa0hoG6fzsqYIQwNV5I Ra+O+/sfjo0cMGGoexFBoggSRZAogkRRBIkiSBRBoggSRREkiiBRBIkiSCuVxhR1J5DCZri6fiaC 1R5VmiM3ff9hInlw9JndBayvc4w7wtQaiGyY5HDZxEFWc6FvRdHncqc46vuugY/PJsUNkedgju9+ jlDJmypTFtwgx4X6sPeVW3YRaEvKAJ/xTZIEKX6QZuBgDE+daUMKU6kOJL3BL7dsitOeJt9JoON9 t374m4oXJN9Fop0j38DCFWCaBzCtQTo5Pi0Pjw58h6UCM8INfBJpJ4F2k2gzQM/x0duY5cvaFBXp i/izW7YijQFS0TRHCkvbyJzzZNq2bYIUP0gzpNAZKtM5St2qObKp99/DNDeQLEDhGUrcTlDaCFOc q7UcHEwQKpdu3Rh5a1ZuK4X7I9nOgR7chz1EnGzHr9xUp5lZufuVWxHuj1QBwsBk90lKXbWviYo3 lXyJ83sk5cYuLGuNpQkwedX1NBGkdpS4irfa+m8LqAhQO9Op/NdmpBRFUf+P/ggwALS/FbNUS0lH AAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 350.3305 61.3232)"
  }), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M482.4,93.2H361c-2.8,0-5-2.2-5-5V71.8c0-2.8,2.2-5,5-5h121.4c2.8,0,5,2.2,5,5v16.4 C487.4,91,485.2,93.2,482.4,93.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.05
    },
    width: 144,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJEAAAApCAYAAAA1Qcs7AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA0JJREFUeNrsnFtP20AQhTf2hiYl NLT0IlpVqqpK7WP//6/gEZ7bh96AQgKE3MwMOoMmayelKlIl7znSkYMd8+JPZ8bOjkOgqH9UZ9PB T58/3vu7VOtU2YfDg6O/h8jB03EmTHnB47fVJpg6G+ApEts+qv0QqZeJ18IUE4AsdUoc64q3sI0E KRuAFuK5eArP4aUvc7UkEogMIIPnsXhbPMDnR4CrYFlrdRlTgGbiK/GFeIztxIPk06iTpFAELArO U/FzeAiQuq60Ue0ESUG5Fo/Ex+Kf2J4DrJklloEUHUwlINH02RO/Fr8Vv8HfOyhthKi9WiKJLsWn 4m8Ij8Ids+1dWYsuhUqk0BPxK/E78QeA9ALpRIjygEgT5wQVqHTpdO1K2kpj7XuhPsrYPiB6D4j2 QGRkY936crYALEOExhw90Tn6ozuQJIBuS1pazvpIopcAaR+ppPt6LoWYRO2FaIm+pwtYFJxf4h/o jUYAqWMlzd+2lyBvAGh2QePANdUEKI+SVgKQISrTMzDhb67qz4lwIAKkHlKph5NK9kLZyADp4vqn j3l8C3SbRukzn8LBFBN4CFAe6rjqZA+bzbEpTIrkZA9SEZp/O6PyAKlwvXLpAqUWKrzTou6bSmvD hBBRD9ZEURQhoggRRYgoQkRRhIgiRBQhoggRRT04RJUzRYVQn0VrhCgdVEtnjQhVftA0zZ9VTUD5 JLIvzhPb/kCQsgLIWJg5L0LD7FlsOEmXPl7BOmukw2t+VSOXhbQfogWuu17/S9hYWKRpFJMTFSBd lH0m/o3tNsDZYiOehSxMLsDAKWxzZ7VJ2BSiCb6sC7J15kjX1ZbYbxOwVLtlKaQL8nVx/lewcAKw piEdGTo8OKp09MMl0RlOGgAypW/XQcRy1v5SZmGiEH0BSMcJRLUJWA+RERhxgp68A4i4WD8fiMa4 9t9dEl1uKmdWC2egrcA/G+Mf9MPqqAhBavdd2RQVaIS+yAYXJ0ljvQpD8lYQTZ2msSHCk09jPQM0 E1Soadj0VpAGkGx1v40OcWwonzQykGwuf46tJVCVvuSqBgVACqF5ZIgQ5QVS+mtF1fTKvbVQOJgI T94wVX968SdFUdT/140AAwBapDJjkkXlOgAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 373.3305 126.3232)"
  }), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M504.7,158.5H383.3c-2.8,0-5-2.2-5-5v-16.4c0-2.8,2.2-5,5-5h121.4c2.8,0,5,2.2,5,5v16.4 C509.7,156.2,507.5,158.5,504.7,158.5z"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M504.5,232l-121-0.8c-2.9,0-5.3-2.4-5.3-5.3v-28.8c0-2.9,2.4-5.3,5.3-5.3l121,0.8c2.9,0,5.3,2.4,5.3,5.3 v28.8C509.7,229.6,507.4,232,504.5,232z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M504.5,288l-121-0.8c-2.9,0-5.3-2.4-5.3-5.3v-28.8c0-2.9,2.4-5.3,5.3-5.3l121,0.8c2.9,0,5.3,2.4,5.3,5.3 v28.8C509.7,285.6,507.4,288,504.5,288z"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 381.5551 244.6003)",
    className: "st92 st119"
  }, "Events")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 409.8217 145.2743)",
    className: "st92 st119"
  }, "Bathroom Faucet")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 404.7515 211.9797)",
    className: "st92 st119"
  }, "Rent")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 422.809 202.2531)",
    className: "st92 st119"
  }, "Due: 4/20/2022")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 409.8217 150.0207)",
    className: "st100 st121"
  }, "Response required for further action")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 402.6316 218.5234)",
    className: "st100 st121"
  }, "$1100.99")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 436.6225 211.9797)",
    className: "st92 st119"
  }, "Utilites")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 438.5919 218.5234)",
    className: "st100 st121"
  }, "213.43")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 470.0574 212.206)",
    className: "st92 st119"
  }, "Amenities")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 478.7183 218.0143)",
    className: "st100 st121"
  }, "59.00")), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M498.7,150.4h3.4c1,0,1.8-0.8,1.8-1.8v-3.4c0-1-0.8-1.8-1.8-1.8h-3.4c-1,0-1.8,0.8-1.8,1.8v3.4 C497,149.6,497.7,150.4,498.7,150.4z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 499.3095 148.1279)",
    className: "st12 st92 st135"
  }, "2"))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M396.8,138.4H388c-1.3,0-2.3,1-2.3,2.3v11.5c0,0.1,0,0.2,0.1,0.3l1.2,1.4c0.2,0.2,0.5,0.2,0.7,0l1-1.2 c0.2-0.2,0.5-0.2,0.7,0l1,1.2c0.2,0.2,0.5,0.2,0.7,0l1-1.2c0.2-0.2,0.5-0.2,0.7,0l1,1.2c0.2,0.2,0.5,0.2,0.7,0l1-1.2 c0.2-0.2,0.5-0.2,0.7,0l1,1.2c0.2,0.2,0.5,0.2,0.7,0l1.2-1.4c0.1-0.1,0.1-0.2,0.1-0.3v-11.5 C399.1,139.5,398.1,138.4,396.8,138.4z M388.6,140.3c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5 C387.1,141,387.7,140.3,388.6,140.3z M395.3,146.8c0,0-0.1,0.1-0.1,0.1h-7.9c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0-0.1,0.1-0.1 c0,0,0.1-0.1,0.1-0.1h7.9c0.1,0,0.2,0.1,0.2,0.2C395.3,146.8,395.3,146.8,395.3,146.8z M387.1,145.7c0-0.1,0-0.1,0.1-0.1 c0,0,0.1-0.1,0.1-0.1h6.9c0.1,0,0.2,0.1,0.2,0.2c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1h-6.9 C387.2,145.9,387.1,145.8,387.1,145.7z M396.7,144.8c0,0-0.1,0.1-0.1,0.1h-9.3c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0-0.1,0.1-0.1 c0,0,0.1-0.1,0.1-0.1h9.3c0.1,0,0.2,0.1,0.2,0.2C396.8,144.7,396.7,144.8,396.7,144.8z M396.8,142.7c0,0.3-0.3,0.6-0.6,0.6 h-4.7c-0.3,0-0.6-0.3-0.6-0.6V141c0-0.3,0.3-0.6,0.6-0.6h4.7c0.3,0,0.6,0.3,0.6,0.6V142.7z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M490,318.2v10h1.5c0.6,0,1.1,0.5,1.1,1.1v1.4h2.6v-2.5c0-0.2,0.2-0.4,0.4-0.4h1.3v2.9h0.5v-2.9h1.3 c0.2,0,0.4,0.2,0.4,0.4v2.5h4.4V330c-0.3-0.2-0.5-0.5-0.5-0.9c0-0.3,0.1-0.6,0.3-0.8c-0.1-0.1-0.1-0.3-0.1-0.5 c0-0.5,0.4-0.9,0.9-0.9c0.1,0,0.2,0,0.3,0v-8.8H490z M494,325.4c0,0.2-0.2,0.4-0.4,0.4h-1.4c-0.2,0-0.4-0.2-0.4-0.4v-1.9 c0-0.2,0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4V325.4z M494,321.7c0,0.2-0.2,0.4-0.4,0.4h-1.4c-0.2,0-0.4-0.2-0.4-0.4v-1.9 c0-0.2,0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4V321.7z M496.2,319.8c0-0.2,0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4v1.9 c0,0.2-0.2,0.4-0.4,0.4h-1.4c-0.2,0-0.4-0.2-0.4-0.4V319.8z M498.8,327.4h-3.1c-0.2,0-0.4-0.2-0.3-0.3c0.2-0.7,1-1.3,1.9-1.3 c0.9,0,1.7,0.6,1.9,1.3C499.1,327.2,499,327.4,498.8,327.4z M502.5,325.4c0,0.2-0.2,0.4-0.4,0.4h-1.4c-0.2,0-0.4-0.2-0.4-0.4 v-1.9c0-0.2,0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4V325.4z M502.5,321.7c0,0.2-0.2,0.4-0.4,0.4h-1.4 c-0.2,0-0.4-0.2-0.4-0.4v-1.9c0-0.2,0.2-0.4,0.4-0.4h1.4c0.2,0,0.4,0.2,0.4,0.4V321.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M505.1,317.7h-15.8c-0.5,0-0.7-0.5-0.3-0.7l0.9-0.6c0.1-0.1,0.2-0.1,0.3-0.1h14c0.1,0,0.2,0,0.3,0.1 l0.9,0.6C505.8,317.2,505.6,317.7,505.1,317.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M492.2,329.2v1.4h-2.8v-1.4c0-0.3,0.3-0.6,0.6-0.6h1.5C491.9,328.6,492.2,328.9,492.2,329.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M504.4,330.1v0.5h-0.5v-0.5c0.1,0,0.2,0,0.3,0C504.2,330.2,504.3,330.1,504.4,330.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M505,329.1c0,0.3-0.1,0.5-0.3,0.7c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.2,0.1-0.5,0.3-0.6 c0.2,0.2,0.4,0.2,0.6,0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.3-0.1,0.4-0.2C504.9,328.6,505,328.8,505,329.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M504.8,327.8c0,0.1,0,0.2-0.1,0.3c0,0,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1 c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0-0.3-0.1-0.4-0.2c0,0-0.1-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.4,0.3-0.7,0.7-0.7c0.1,0,0.2,0,0.3,0.1C504.6,327.3,504.8,327.5,504.8,327.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000047761999349736894400000013766317582613173159_",
    cx: 408.3463,
    cy: 321.2676,
    r: 24.2781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDB44D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#E97B00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047761999349736894400000013766317582613173159_)"
    },
    d: "M417.9,325.2h4.8 c0.8,0,1.5,0.7,1.5,1.5v3.1c0,0.8-0.7,1.5-1.5,1.5h-4.8c-0.8,0-1.5-0.7-1.5-1.5v-3.1C416.4,325.9,417.1,325.2,417.9,325.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000138562711297547728540000003478351871973883068_",
    cx: 408.3463,
    cy: 321.2676,
    r: 24.2781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDB44D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#E97B00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138562711297547728540000003478351871973883068_)"
    },
    d: "M418.2,315h4.2c1,0,1.8,0.8,1.8,1.8 v5.3c0,1-0.8,1.8-1.8,1.8h-4.2c-1,0-1.8-0.8-1.8-1.8v-5.3C416.4,315.9,417.2,315,418.2,315z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000026124618680492883000000001371986238780862364_",
    cx: 408.3463,
    cy: 321.2676,
    r: 24.2781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDB44D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#E97B00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026124618680492883000000001371986238780862364_)"
    },
    d: "M432.2,321.2h-4.8 c-0.8,0-1.5-0.7-1.5-1.5v-3.1c0-0.8,0.7-1.5,1.5-1.5h4.8c0.8,0,1.5,0.7,1.5,1.5v3.1C433.7,320.5,433,321.2,432.2,321.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000022523372706775917180000004244099007567773318_",
    cx: 408.3463,
    cy: 321.2676,
    r: 24.2781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDB44D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#E97B00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022523372706775917180000004244099007567773318_)"
    },
    d: "M431.9,331.4h-4.2 c-1,0-1.8-0.8-1.8-1.8v-5.3c0-1,0.8-1.8,1.8-1.8h4.2c1,0,1.8,0.8,1.8,1.8v5.3C433.7,330.6,432.9,331.4,431.9,331.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000138555438629756389090000017568565433917472673_",
    cx: 450.7707,
    cy: 309.3857,
    r: 21.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22B573"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#83CC79"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138555438629756389090000017568565433917472673_)"
    },
    d: "M457.2,319.8 c-0.9,0.9-1.5,2.2-1.5,3.5h-1.7c-0.1,0-0.2,0.1-0.2,0.2v1.8c0,0.2-0.2,0.3-0.4,0.1l-2.8-3.2l0,0c-0.5-0.6-0.9-1.4-0.9-2.3 c0-1.8,1.5-3.2,3.3-3.2h4.8c0.9,0,1.7,0.4,2.3,1c0.2,0.2,0.3,0.4,0.4,0.5c0,0,0,0,0,0C459.4,318.3,458.1,318.9,457.2,319.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000104681067040644892290000012342921673892647871_",
    cx: 450.7707,
    cy: 309.3857,
    r: 21.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22B573"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#83CC79"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104681067040644892290000012342921673892647871_)"
    },
    d: "M467.1,319.1h-6.3 c-1.2,0-2.3,0.5-3,1.3c-0.8,0.8-1.2,1.8-1.3,3v0c0,2.4,1.9,4.3,4.3,4.3h5.1c0.2,0,0.3,0.1,0.3,0.3v2.3c0,0.3,0.3,0.4,0.5,0.2 l3.6-4.2l0,0c0.7-0.8,1.1-1.8,1.1-3C471.4,321,469.4,319.1,467.1,319.1z M461.2,324.4c-0.5,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1 S461.8,324.4,461.2,324.4z M464,324.4c-0.5,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S464.5,324.4,464,324.4z M466.7,324.4 c-0.5,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S467.2,324.4,466.7,324.4z"
  })), /*#__PURE__*/React.createElement("g", null, _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 385.2902 80.286)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st92 st119"
  }, "Leasing O"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.3,
    y: 0,
    className: "st92 st119 st113"
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.6,
    y: 0,
    className: "st92 st119 st142"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 29.1,
    y: 0,
    className: "st92 st119"
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.7,
    y: 0,
    className: "st92 st119 st143"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 31,
    y: 0,
    className: "st92 st119"
  }, "ice"))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 385.2902 85.0329)",
    className: "st100 st121"
  }, "Preview of message...")), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M475.5,82.3h3.3c0.9,0,1.7-0.8,1.7-1.7v-3.3c0-0.9-0.8-1.7-1.7-1.7h-3.3c-0.9,0-1.7,0.8-1.7,1.7v3.3 C473.8,81.6,474.6,82.3,475.5,82.3z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 476.0827 80.186)",
    className: "st12 st92 st145"
  }, "4"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000107562543795446918790000002917292113555565463_",
    cx: 359.9111,
    cy: 67.1998,
    r: 21.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22B573"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#83CC79"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107562543795446918790000002917292113555565463_)"
    },
    d: "M366.3,77.6 c-0.9,0.9-1.5,2.2-1.5,3.5h-1.7c-0.1,0-0.2,0.1-0.2,0.2v1.8c0,0.2-0.2,0.3-0.4,0.1l-2.8-3.2l0,0c-0.5-0.6-0.9-1.4-0.9-2.3 c0-1.8,1.5-3.2,3.3-3.2h4.8c0.9,0,1.7,0.4,2.3,1c0.2,0.2,0.3,0.4,0.4,0.5c0,0,0,0,0,0C368.5,76.1,367.3,76.7,366.3,77.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000066485746116167115220000000308097028110666150_",
    cx: 359.9111,
    cy: 67.1998,
    r: 21.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22B573"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#83CC79"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066485746116167115220000000308097028110666150_)"
    },
    d: "M376.2,76.9h-6.3 c-1.2,0-2.3,0.5-3,1.3c-0.8,0.8-1.2,1.8-1.3,3v0c0,2.4,1.9,4.3,4.3,4.3h5.1c0.2,0,0.3,0.1,0.3,0.3v2.3c0,0.3,0.3,0.4,0.5,0.2 l3.6-4.2l0,0c0.7-0.8,1.1-1.8,1.1-3C380.5,78.8,378.5,76.9,376.2,76.9z M370.4,82.2c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1 s1,0.4,1,1C371.3,81.8,370.9,82.2,370.4,82.2z M373.1,82.2c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1 C374.1,81.8,373.6,82.2,373.1,82.2z M375.8,82.2c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1s1,0.4,1,1 C376.8,81.8,376.4,82.2,375.8,82.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000031192878193588785950000018117923292480493499_",
    cx: 372.3002,
    cy: 313.0345,
    r: 21.8712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0000FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#2E67CE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031192878193588785950000018117923292480493499_)"
    },
    d: "M387.9,322.8c0,1.1-0.5,2.1-1.3,2.7 h-0.7v-2.7c0-0.8-0.7-1.5-1.5-1.5c-0.8,0-1.5,0.7-1.5,1.5v3.2c-1.3-0.5-2.2-1.8-2.2-3.3c0-2,1.6-3.6,3.6-3.6 C386.3,319.2,387.9,320.8,387.9,322.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000036214487718788645150000014987751166266092425_",
    cx: 372.3002,
    cy: 313.0345,
    r: 21.8712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0000FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#2E67CE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036214487718788645150000014987751166266092425_)"
    },
    d: "M384.3,314.5c-4.6,0-8.3,3.7-8.3,8.3 c0,4.1,3,7.5,6.9,8.2c0-0.1,0-0.2,0-0.2v0l-0.4-1.3c-2.9-0.8-5-3.4-5-6.6c0-3.8,3.1-6.8,6.8-6.8c3.8,0,6.8,3.1,6.8,6.8 c0,1.7-0.6,3.3-1.7,4.5c0,0,0,0.1,0,0.1v0l-0.2,2c2.1-1.5,3.4-3.9,3.4-6.7C392.6,318.2,388.9,314.5,384.3,314.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000080183688925822669070000014382340495077038263_",
    cx: 372.3002,
    cy: 313.0345,
    r: 21.8712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0000FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#2E67CE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080183688925822669070000014382340495077038263_)"
    },
    d: "M388.7,327.4l-0.1,0.7l-0.2,1.9 l-0.1,0.7c0,0.6-0.5,1.1-1.1,1.1h-2.4c-0.5,0-0.9-0.3-1.1-0.8c0-0.1-0.1-0.2-0.1-0.3v-0.2l-0.3-1l-0.5-1.6c0-0.1,0-0.2,0-0.3 c0-0.4,0.2-0.7,0.6-0.8c0.1,0,0.2,0,0.2,0v-4c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v3.4h2.5 C388.2,326.3,388.7,326.8,388.7,327.4z"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M392,215.2h-7.1c-1.7,0-3.1-1.4-3.1-3.1v-3.9c0-1.7,1.4-3.1,3.1-3.1h7.1c1.7,0,3.1,1.4,3.1,3.1v3.9 C395.1,213.8,393.7,215.2,392,215.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "389.8,214.3 388.5,213.2 387.1,214.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M394.1,207.8h-5.3v1.1h-2v2.2h3.7v-1.8h3.7v-0.8C394.2,208.3,394.2,208.1,394.1,207.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.2,
    y: 210.1,
    className: "st39",
    width: 3,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M388.6,207.1h5.1c-0.5-0.7-1.2-1.1-2.1-1.1h-4.1L388.6,207.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M388.1,208.2v-0.6l-1.6-1.6h-1.2c-1.3,0-2.4,1-2.6,2.2H388.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M388.8,211.9v0.6l2.1,1.8h0.6c1.4,0,2.5-1,2.6-2.4H388.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M385.9,214.3l2.2-1.8v-0.6h-5.4c0.1,1.3,1.2,2.4,2.6,2.4H385.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.7,
    y: 209,
    className: "st39",
    width: 3.4,
    height: 2.2
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M398.1,276.5v-4.1c0-0.3-0.2-0.5-0.5-0.5h-4.2c-0.3,0-0.5,0.2-0.5,0.5v4.1c0,0.3,0.2,0.5,0.5,0.5h4.2 C397.8,277.1,398.1,276.8,398.1,276.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M404.4,263.6v-1.6c0-1.6-1.3-2.9-2.9-2.9h-12.2c-1.6,0-2.9,1.3-2.9,2.9v1.6c0,0.3,0.2,0.5,0.5,0.5h16.8 C404.2,264.2,404.4,263.9,404.4,263.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M392.8,265.8v4.4c0,0.3,0.2,0.5,0.5,0.5h4.2c0.3,0,0.5-0.2,0.5-0.5v-4.4c0-0.3-0.2-0.5-0.5-0.5h-4.2 C393.1,265.3,392.8,265.5,392.8,265.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M403.9,265.3h-4.2c-0.3,0-0.5,0.2-0.5,0.5v4.4c0,0.3,0.2,0.5,0.5,0.5h4.2c0.3,0,0.5-0.2,0.5-0.5v-4.4 C404.4,265.5,404.2,265.3,403.9,265.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M399.2,272.4v4.1c0,0.3,0.2,0.5,0.5,0.5h1.8c1.6,0,2.9-1.3,2.9-2.9v-1.8c0-0.3-0.2-0.5-0.5-0.5h-4.2 C399.4,271.8,399.2,272.1,399.2,272.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M387,270.8h4.2c0.3,0,0.5-0.2,0.5-0.5v-4.4c0-0.3-0.2-0.5-0.5-0.5H387c-0.3,0-0.5,0.2-0.5,0.5v4.4 C386.5,270.5,386.7,270.8,387,270.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M391.2,271.8H387c-0.3,0-0.5,0.2-0.5,0.5v1.8c0,1.6,1.3,2.9,2.9,2.9h1.8c0.3,0,0.5-0.2,0.5-0.5v-4.1 C391.8,272.1,391.5,271.8,391.2,271.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M390.5,261.8c-0.6,0-1.1-0.5-1.1-1.1v-1.8c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1v1.8 C391.6,261.3,391.1,261.8,390.5,261.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M390,260.6v-1.8c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v1.8c0,0.3-0.2,0.5-0.5,0.5l0,0 C390.2,261.2,390,260.9,390,260.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M395.5,261.8c-0.6,0-1.1-0.5-1.1-1.1v-1.8c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v1.8 C396.6,261.3,396.1,261.8,395.5,261.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M394.9,260.6v-1.8c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v1.8c0,0.3-0.2,0.5-0.5,0.5l0,0 C395.2,261.2,394.9,260.9,394.9,260.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M400.4,261.8c-0.6,0-1.1-0.5-1.1-1.1v-1.8c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v1.8 C401.5,261.3,401,261.8,400.4,261.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M399.9,260.6v-1.8c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v1.8c0,0.3-0.2,0.5-0.5,0.5l0,0 C400.1,261.2,399.9,260.9,399.9,260.6z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.05
    },
    width: 32,
    height: 25,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAaCAYAAAA5WTUBAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAApdJREFUeNrMV9tu1DAQjRNnt+z2 RgsCARJCPMAj//8VPNLHPtAWRNldesk2146lM9VksGPvWyMdOcnGnuO5nPGaLHJ9/fZFPpos/Rr4 5sf3s8kPTaJho741CcblOEnIBAhIwwUhB0yCNwaBntBhfCKliZgAgQKwhJIww32B3/MIgQ5oCDXG VpAZEbEBAs7wnLAgLIEXeF8I8sYThh5Gt4R7wh3hFs+18sqYhNhhCeOHhBPCKeEl4YCwhzmhsLAX ahheEa4JfwhrfON+G2jTT96wygsWhhyBt4QPhHeEN4QjkCsTSLhdbwi/CT+xrgzTyBtWVUABEs4D 7wmfCZ9A6BghsZGcYBL/sM4c+VABD3g2TESHw8LQMQx/FCQOsWAxUSFcETVIMAF3/xchuUPO9C4C LiRW5UOBiUvkwSvCa4xLhCKPlGkPwyXuHYFfKpx5yBOZIsKVsYB35pGklN4oQGAfxo9UYo82Yj2a oTWiFO/yROnOMX+ODSxAYCY2wjaHPKCguUclTSIBo8LLG5JiZzTjmPT+15B2aGA+eN0W0nyp+/0O ROR8lu0HjC3WHDU5G6jzFpN4gQZI7aIt5lVQzhuU5lb1kFFiSg+0avItEisT5ZVFSrTB3BX0YYVS rQQJb+/gHWyxwDXqex+/V8juGIkOXnBGLwkXWGeNNRr2xKh3qFBUmHAJncjgjQOQiCmm7B1XhHOs tUJXbXSSWpx2XFfrhSfWMJghluyRWUQrJIkbdM8rYI333VQ4OJ7sSm67G6F2MidMoCS5d9yDyEb0 jFqHwneyMkrt9gTKSCh07+CDzVYcaDofCTuxiNyRTTxjytNVL8q9E/owfcZUHsk8sp1y7JdEtFIO SaftAJld/3NkMcPP7noUYABxVSa+3HNsRQAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 484.3305 61.3232)"
  }), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M505.4,79.1h-11.7c-2,0-3.5-1.6-3.5-3.5v-5.2c0-2,1.6-3.5,3.5-3.5h11.7c2,0,3.5,1.6,3.5,3.5v5.2 C508.9,77.5,507.3,79.1,505.4,79.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.05
    },
    width: 32,
    height: 25,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAaCAYAAAA5WTUBAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmBJREFUeNrMVk1PGzEQ9e46kEAI 5bOqVKntCY78/1/RIz1WQhDUQkJDmmw2u2ZcvUHTwbt2OGWlp+xH7Hl+M35jY7bgyto+XF5dJP0v cjm+uf7+I52ECJ4JbErGBX5dG5ksQMC/yxX43SYKeDQK/95rIlmAQEGwhB2gh+dUIkygJqwJK6DC 8xsiVhHKEXRAGAL7hD7I5ZG0sPw1gi4Iz4QZYY5vayz6lYhVKvjnXcKIcEY4J5yAyI5ITUwJH2hJ eCI8EO4xVqrktBKZSIVX4YjwmfCV8InwQagRI9GAxBwEbhCngTo17lvTYQUJH/wb4QvhGO9TSVQg 8QvKelJ/gRLPDafEqnooMGiIwB9B5hQkbGJhctABVv4HqjyiPkrEdCYwqSSyDzIjIFUJzvkuVJmh rg4Jeyj8vCsdBoF4m/YUUkkU+B2IxeyhuK0yQmdbzCsXqmjjSm0FhVqAFYvItPxdhuNCfWBD13Qt 8wVJuIDd1uI+lYgcX8EtS/yulUcECzNktyUmqxIbGe+OMuCYS96eIbOSCqzV4GcUlQlVdodP+LET bMsJtulCkAjuDmm3M2G3Q3xfCOvuumqo4IPeEW4xzxRzVKzEf71DpWKBAXfYXgZqHIBEEWlgtegb Y8JPzDWBgVW6SC0OGo4stBFKTBHQIJesSKyJSRJezd8gMsacy1jv4HyylAaF+QQV+qomso6DzAqr nmH8FItZ6VSETlbcQ7il9wV6G3bRCitnrIQKrYcaPYlckRVpiG1Po3yGvaGOHu8CihgVOEs87Eoi 2ild9KDbQeY9x/7OwFt3vQgwAJuAHXu5QKW4AAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 484.3305 75.3232)"
  }), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M505.4,93.2h-11.7c-2,0-3.5-1.6-3.5-3.5v-5.2c0-2,1.6-3.5,3.5-3.5h11.7c2,0,3.5,1.6,3.5,3.5v5.2 C508.9,91.6,507.3,93.2,505.4,93.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.05
    },
    width: 45,
    height: 22,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAXCAYAAAB0zH1SAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAYtJREFUeNrsl9tKxDAQhts0Vlfx fKGod4KK3vj+T7FXoqAieADPVl332MQ/8kdCbL2TacHAx7JpYL+ZnWaSNKkYe4e7adKgcdw9sfFc WiEcIzlsSBhAGkkrMAVyoEEmLF6CCRiBMTBeXkfZd8LzYAUs8LsSkjYUfgNP/BwiwV/yOsr2DFgD O2CLQWQCJWOZ7R64AafgknMu8zbMuBPvUHwfHIBVZl1iuBIpwBkDeQd9ziexuKvvRbAJtsE6xVOh +i74+4/gmiUzcOWio8UZF86yxpfAtKB4znLZAMt0UXHGw5c04zOPhLh/5+b4rnVCF5U0d/gNQ7OE dejbZPEwgB/NsA3itXX0L/7XZ5Xwgf6la01IJrSrGHZJ1/aHdDF14iUXfoBX7ue5oLjrlA/gmfv5 2MvriggLdinXfF4EW75hAq/AOQMY1Im7CG/BETMueciy9LkHF/Tq+6NteB5XbKlNOdZaVkCPpVJQ vPw+1gYLR8y0+0vuGnCRMNFFovQXifZf3dp2WW7t+BRgABu9k1mNfBuwAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 469.0867 95.0794)"
  }), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M506.8,111.7h-31.8c-1.2,0-2.1-0.9-2.1-2.1v-8.3c0-1.2,0.9-2.1,2.1-2.1h31.8c1.2,0,2.1,0.9,2.1,2.1v8.3 C508.9,110.8,508,111.7,506.8,111.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.05
    },
    width: 45,
    height: 21,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAWCAYAAAC/kK73AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAWRJREFUeNrsl09LAzEQxZtstLbi /4OC3gQVvfj9P4Un0Yt60ENV0Kp1a9vd+kZeIIzdXieFBn6Q3eTw5u1kZ+JaM8bZ5alrZTRurm6n +p2bIVhjOaYpaQBOifZgBayCAApj4TWYgBEYgyqKD8p9EbwBdsEmn72h2yJ2AN5AH5Qw+E98UG6v gX1wAo4YRGGQMjE9SvACHsA950NZSx0X4R0KPwcXYI+uW6XJN3gEXc6/JG1g9D/hkt9b4BAcgwMK d0bCS371T7r+xHkV1OaCQrvM8W3QNhTeofgdsE5jvT6c6SEtuBZxRoezopFt6vBpeuQ8GmtK7sIb x1L4UvicXiVdCHNO84RYVM74OxyzT/mhlrpJeMWNUqU++D+3LkCv7FUGDKTWwmOEfVYoKT7vmZT8 OwYwbBIuEfbANR3Pqcnq8bmW7jDtxz0rVNZtbezJg9o4otPySZ5zvkgs/tVt0S7LvwIMAA8wlSXi 1CLCAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 469.0867 109.0794)"
  }), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M506.8,125.6h-31.8c-1.2,0-2.1-0.9-2.1-2.1v-8.3c0-1.2,0.9-2.1,2.1-2.1h31.8c1.2,0,2.1,0.9,2.1,2.1v8.3 C508.9,124.7,508,125.6,506.8,125.6z"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 495.2155 73.9006)",
    className: "st12 st100 st151"
  }, "Clear"))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 493.1984 88.3988)",
    className: "st12 st100 st151"
  }, "Clear All"))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 491.69 107.9513)",
    className: "st12 st100 st152"
  }, "Clear"))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 487.4444 120.9284)",
    className: "st12 st100 st152"
  }, "Clear All"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.05
    },
    width: 144,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJEAAAApCAYAAAA1Qcs7AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA41JREFUeNrsnFlv01AQhb2lbWha UsqigpAQQiqP/P9fwSM8I6BAoUto9oUZeiaMbx3XorxwfY505Li289JPZ8bOHScJRd1Rad3B12+O G59LRaWVfXj39v3fQeTgSZ0JU3vg8dtbgUpr4MkC29+ouCEyL8ULbNfHqkBKA4AsdXJxIe6It7At CFIrAFJo5uKZ8xxAVYJUBEClDp574l1xD5+3AVfGshZtGTOAJuKh+Aoeiac4poFTAikNUqgALArO gfghfB8gdVxpo+IDaQFYFKAL8Q/4TPxTPAZIpUQqHEw5INH0ORQ/FT8XP8P+HkobIYobIk2hAeA5 EX90nCzdeeuGu3AplCOF9sVPxC/ErwDSI6QTIWpHEmkJ+45qtIPj1if5ZnudRL4X6uLCI0D0EhAd opwVbKyjb6xn6IH6DqAxytkVkkqBWlpvFJazLpLoMUA6Qirt4wuziudGVDxawruoSgaQ9kTfUOIG ACm1kuZv23OUqx6g6aOh7rmmmgC1I41y7E9QhR5U3FxV3uJn2N9C6nSx7bhbewIUtyxdjIMuUmnP PebxLdDv88NnPpmDqQjgIUDtAcmqkz1sNhdVYZIFF3uQsqT6tzOqHSBlrlfOXaDcCBXeaVFNU2lj mBAi6s4iRBQhoggRRYgoihBRhIgiRBQhoihCRDVVOEp0K0R+bIRqLzR++sO8qgIqqyBtVXERoWon SDZ7Nk+CsaFNSWTgzAMvCVArAVJgdKmsLkwbYztLyov0VwZROLSmJ49gvXgawMRUiruELR1A+v/X ddW6vnroQCoFSxGQN8FFOnN0Lr5Mrle12Xm6poRrjOKGyM+eXYIDY2HoAiXZBNEYJ+u4yJfkel1t B8d0maStbiNE8ZawOaqQgqOL87+KTxEsI59E6+FF+bDS0Q+XRBcAyIYVF0gnBaqb/FlzTYjikrUz Nh6kkx2fxB/Aw3kSTMDWlbMBLirwN93X4cU+0miHaRR1Iz3E/1zT5wQQfXZJtLGcGYkzpE6G/RGI PEASGUQcH4oToqmD6AxtzSm2AxwvlbI1RChpCSgzzfGFClEPVoD4dpB478rsjmyIkmYuTb6GXxC+ 5Cp8P5EfF9lOasZGqCh6IitpU0AzhWf+MU/4fqIbIAAke4Zkk7G1IyNUFGlkIBlM5tKvF7VvSquB yT8XyppcS/3XIK2qXPcC0EYgOKAIT4tgavLmWIr6J/olwACHK2gIRzlgTAAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 349.3305 93.3232)"
  }), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M480.7,125.6H359.2c-2.8,0-5-2.2-5-5v-16.4c0-2.8,2.2-5,5-5h121.4c2.8,0,5,2.2,5,5v16.4 C485.7,123.4,483.4,125.6,480.7,125.6z"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M473.8,115.7h3.3c0.9,0,1.7-0.8,1.7-1.7v-3.3c0-0.9-0.8-1.7-1.7-1.7h-3.3c-0.9,0-1.7,0.8-1.7,1.7v3.3 C472.1,115,472.8,115.7,473.8,115.7z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 474.3286 113.5893)",
    className: "st12 st92 st153"
  }, "2"))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M362.6,117.9c0,0-0.1,0.1-0.2,0.1h-1.4c-0.1,0-0.2-0.1-0.2-0.2v-2.9h1.4l0.5,2.8 C362.7,117.7,362.7,117.8,362.6,117.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "375.2,111.8 375.2,111.8 375.2,111.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "374.5,112.1 374.5,112.1 374.5,112.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "375.2,111.8 375.2,111.8 375.2,111.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "375.2,111.8 375.2,111.8 375.2,111.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "375.2,111.8 375.2,111.8 375.2,111.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M362.9,110v4.4h-2.6c-0.4,0-0.8-0.3-0.8-0.8v-0.7h-0.3c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3 v-0.6c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.1-0.1,0.2-0.1h0.3v-0.7c0-0.4,0.3-0.8,0.8-0.8H362.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "375.2,111.8 375.2,111.8 375.2,111.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M374.5,112.1L374.5,112.1L374.5,112.1L374.5,112.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M376.4,111.9c0,0,0-0.1,0-0.1v0c0-0.2-0.1-0.3-0.1-0.4c-0.1-0.2-0.2-0.3-0.3-0.5 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.2-0.4-0.3-0.7-0.4v3.9c0.2-0.1,0.5-0.2,0.7-0.4c0.1-0.1,0.2-0.2,0.3-0.3 c0.1-0.1,0.2-0.3,0.3-0.5c0-0.1,0-0.1,0.1-0.2c0-0.2,0.1-0.3,0.1-0.5c0,0,0-0.1,0-0.1C376.4,112.1,376.4,112,376.4,111.9z  M375.2,111.8L375.2,111.8L375.2,111.8L375.2,111.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "374.5,112.1 374.5,112.1 374.5,112.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "375.2,111.8 375.2,111.8 375.2,111.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "374.5,112.1 374.5,112.1 374.5,112.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M374.5,107.6v4.5l0,0l0,0v4.5c0,0.5-0.5,0.8-0.9,0.6l-7.9-2.7v-4.9l7.9-2.7 C374.1,106.8,374.5,107.1,374.5,107.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "374.5,112.1 374.5,112.1 374.5,112.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M365.2,109.4v5.5c0,0,0,0.1,0,0.1c0,0.2-0.2,0.4-0.5,0.4h-0.8c-0.3,0-0.5-0.2-0.5-0.5v-5.5 c0-0.3,0.2-0.5,0.5-0.5h0.8C364.9,108.9,365.2,109.1,365.2,109.4C365.2,109.3,365.2,109.4,365.2,109.4z"
  }))))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M529.8,79.8V25.2c0-13.9-11.3-25.2-25.2-25.2H383.3c-13.9,0-25.2,11.3-25.2,25.2v21.4h-0.8V60h0.8v11.3 c-0.5,0.4-0.9,1-0.9,1.7v22.5c0,0.7,0.3,1.3,0.9,1.7v6.3c-0.5,0.4-0.9,1-0.9,1.7v22.5c0,0.7,0.3,1.3,0.9,1.7V323 c0,13.9,11.3,25.2,25.2,25.2h121.2c13.9,0,25.2-11.3,25.2-25.2V120.5c0.6-0.1,1.1-0.7,1.1-1.3V81.1 C530.8,80.5,530.4,79.9,529.8,79.8z M520.4,323.4c0,9-7.3,16.2-16.2,16.2H383.7c-9,0-16.2-7.3-16.2-16.2V25.3 c0-9,7.3-16.2,16.2-16.2h15.6c1.2,0.1,2.1,1,2.1,2.1v1.4c0,4.7,3.8,8.5,8.5,8.5h68c4.7,0,8.5-3.8,8.5-8.5v-1.3h0 c0-1.2,0.9-2.2,2.1-2.2h15.7c9,0,16.2,7.3,16.2,16.2V323.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.1,1.9h-122c-12.5,0-22.6,10.1-22.6,22.6v299.2c0,12.5,10.1,22.6,22.6,22.6h122c12.5,0,22.6-10.1,22.6-22.6V24.5 C527.7,12,517.6,1.9,505.1,1.9z M520.4,323.4c0,9-7.3,16.2-16.2,16.2H383.7c-9,0-16.2-7.3-16.2-16.2V25.3 c0-9,7.3-16.2,16.2-16.2h15.6c1.2,0.1,2.1,1,2.1,2.1v1.4c0,4.7,3.8,8.5,8.5,8.5h68c4.7,0,8.5-3.8,8.5-8.5v-1.3h0 c0-1.2,0.9-2.2,2.1-2.2h15.7c9,0,16.2,7.3,16.2,16.2V323.4z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomely03);
export default __webpack_public_path__ + "static/media/Homely-03.b41654e49055e30672e0a0d355d82bcd.svg";
export { ForwardRef as ReactComponent };